import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTasteWheelFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "tastewheel",
	xmlns: "http://www.w3.org/2000/svg",
	width: 878.7401733,
	height: 878.7401733,
	viewBox: "0 0 878.7401733 878.7401733",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "flavor",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					id: "flavour-inner-circle",
					className: "panel-flavour-inner",
					cx: 412.3608627,
					cy: 471.0583496,
					r: 100.7499886,
					fill: "#e25d2c",
					stroke: "#fff",
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "flavor-panel",
					children: /* @__PURE__ */ _jsx("path", {
						className: "flavor-panel-outer-background",
						d: "M712.5773926,470.7965393c0,129.47995-82.0200195,239.8000183-196.9399414,281.8300476l-12.6801758-34.7700195-11.9897461-32.9001465-7.880127-21.6098633c78.4799805-28.7399902,134.4899902-104.1000977,134.4899902-192.5500488,0-113.2199707-91.7800293-205-205-205-70.1999512,0-132.1599121,35.2900391-169.1098633,89.0898438l-18.9902344-12.9599609-28.9199219-19.7397461-30.5500488-20.8601074c54.0500488-78.8300781,144.7700195-130.5300293,247.5700684-130.5300293,165.6899414,0,300,134.3100586,300,300v.0000305Z",
						fill: "#e25d2c"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "flavour-outer-items",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-pear",
							className: "outer-panel",
							"data-key": "pear",
							d: "M603.2192383,395.2588501l88.3740234-34.9050293c-1.9372559-4.8894043-4.0078125-9.7109375-6.1906738-14.470459l-86.4211426,39.4799805c1.4943848,3.2546387,2.9116211,6.5517578,4.237793,9.8955078Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-roastedhazelnut",
							className: "outer-panel",
							"data-key": "roasted_hazelnut",
							d: "M342.4721375,278.1035767l-32.2355957-89.3789062c-4.7502441,1.723877-9.4467773,3.5598145-14.081543,5.5134277l36.7011719,87.6403809c3.1650391-1.3374023,6.3720703-2.5942383,9.6159668-3.7749023Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-unroastedcocoa",
							className: "outer-panel",
							"data-key": "unroasted_cocoa",
							d: "M250.0187836,345.9087524l-75.2229004-58.0078125c-3.3681641,4.3725586-6.6203613,8.8383789-9.7480469,13.3972168l78.3190918,53.7617188c2.1340332-3.1140137,4.3535156-6.1640625,6.6518555-9.151123Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-liquorice",
							className: "outer-panel",
							"data-key": "liquorice",
							d: "M521.5268555,644.4854126l50.6828613,80.3508301c4.3815918-2.7590332,8.6899414-5.6230469,12.9150391-8.5986328l-54.7634277-77.625c-2.8903809,2.0324707-5.8371582,3.9885254-8.8344727,5.8728027Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-error",
							className: "outer-panel",
							"data-key": "error",
							d: "M243.3669281,355.0598755l-78.3190918-53.7617188c-.0098877.0144043-.0198975.0285645-.0297852.0429688l78.3283691,53.7480469.0205078-.0292969Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-jasmine",
							className: "outer-panel",
							"data-key": "jasmine",
							d: "M512.4025879,649.8950806l46.4677734,82.8637695c4.5195312-2.5292969,8.9677734-5.1699219,13.3393555-7.9226074l-50.6828613-80.3508301c-2.9902344,1.8793945-6.0327148,3.6828613-9.1242676,5.409668Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-lavender",
							className: "outer-panel",
							"data-key": "lavender",
							d: "M482.9953308,663.3994751l32.8760071,89.1499023c5.1313477-1.8818359,10.1896973-3.9130859,15.1853027-6.0627441l-37.6762695-87.2214355c-3.4162598,1.4663086-6.8759766,2.8510742-10.3850098,4.1342773h-.0000305Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-violet",
							className: "outer-panel",
							"data-key": "violet",
							d: "M503.0763855,654.7944946l42.1582336,85.1416016c4.6137695-2.2783203,9.159668-4.6723633,13.6357422-7.1772461l-46.4677734-82.8637695c-3.0615234,1.7099609-6.1704102,3.3444824-9.3261719,4.8994141h-.0000305Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-rose",
							className: "outer-panel",
							"data-key": "rose",
							d: "M493.3803406,659.2651978l37.6763,87.2214355c4.7927246-2.0622559,9.5183105-4.2492676,14.1779785-6.5505371l-42.1582031-85.1416016c-3.1867676,1.5705566-6.418457,3.0634766-9.6960449,4.4707031h-.0000305Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-alkali",
							className: "outer-panel",
							"data-key": "alkali",
							d: "M256.7638855,337.5930786l-72.083252-61.8649902c-3.3996582,3.9682617-6.692627,8.0290527-9.8847656,12.1728516l75.2229004,58.0078125c2.1779785-2.8308105,4.425293-5.6047363,6.7451172-8.3156738Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-volatileacidity",
							className: "outer-panel",
							"data-key": "volatile_acidity",
							d: "M271.1662292,322.3821411l-65.3782959-68.9125977c-3.6862793,3.5085449-7.2805176,7.1125488-10.78479,10.8029785l68.8051758,65.4936523c2.3913574-2.5217285,4.8422852-4.9863281,7.3579102-7.3840332Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-roastedcocoa",
							className: "outer-panel",
							"data-key": "roasted_cocoa",
							d: "M313.8632507,291.0999146l-45.5266113-83.3896484c-4.5761719,2.5144043-9.0754395,5.1491699-13.5021973,7.8913574l49.810791,80.8952637c3.0219727-1.8754883,6.0939941-3.677002,9.2180176-5.3969727Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-mocha",
							className: "outer-panel",
							"data-key": "mocha",
							d: "M332.8561707,281.878479l-36.7011719-87.6403809c-4.8967285,2.0639648-9.7241211,4.2590332-14.484375,6.5715332l41.2966309,85.5693359c3.2504883-1.5822754,6.545166-3.0878906,9.888916-4.5004883Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-yoghurty",
							className: "outer-panel",
							"data-key": "yoghurty",
							d: "M304.6452332,296.4968872l-49.810791-80.8952637c-4.4367676,2.748291-8.7946777,5.6098633-13.0732422,8.5791016l53.9592285,78.1821289c2.9206543-2.0302734,5.8959961-3.9865723,8.9248047-5.8659668Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-roastedcoffee",
							className: "outer-panel",
							"data-key": "roasted_coffee",
							d: "M322.9672546,286.3789673l-41.2966309-85.5693359c-4.5097656,2.1906738-8.9541016,4.4941406-13.3339844,6.9006348l45.5266113,83.3896484c2.9904785-1.6462402,6.0249023-3.2219238,9.1040039-4.7209473Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-milky",
							className: "outer-panel",
							"data-key": "milky",
							d: "M278.978241,315.317688l-61.7443848-72.1850586c-3.9016113,3.3508301-7.7224121,6.7927246-11.4459229,10.3369141l65.3782959,68.9125977c2.5412598-2.4221191,5.1491699-4.7741699,7.8120117-7.0644531Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-creamy",
							className: "outer-panel",
							"data-key": "creamy",
							d: "M287.11203,308.6807251l-57.9616699-75.2583008c-4.0549316,3.1381836-8.0305176,6.3728027-11.9165039,9.7102051l61.7443848,72.1850586c2.6523438-2.2810059,5.3662109-4.4919434,8.1337891-6.6369629Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-buttery",
							className: "outer-panel",
							"data-key": "buttery",
							d: "M295.7204285,302.362854l-53.9592285-78.1821289c-4.2858887,2.9741211-8.4914551,6.0539551-12.6108398,9.2416992l57.9616699,75.2583008c2.8117676-2.1791992,5.6831055-4.2844238,8.6083984-6.3178711Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-phenolicbitter",
							className: "outer-panel",
							"data-key": "phenolic_bitter",
							d: "M263.8083191,329.7661743l-68.8051758-65.4936523c-3.5390625,3.7272949-6.9768066,7.5507812-10.3225098,11.4555664l72.083252,61.8649902c2.2832031-2.6682129,4.6293945-5.2800293,7.0444336-7.8269043Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-rummy",
							className: "outer-panel",
							"data-key": "rummy",
							d: "M609.0285645,529.5708618l91.0476074,27.1552734c1.4758301-4.9453125,2.8273926-9.9436035,4.0515137-14.9924316l-92.3256836-22.4169922c-.8378906,3.4533691-1.7629395,6.8718262-2.7734375,10.2541504Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-woodyoak",
							className: "outer-panel",
							"data-key": "woody_oak",
							d: "M602.1589355,548.9446411l87.8818359,36.1101074c1.8623047-4.5175781,3.6166992-9.090332,5.2617188-13.7158203l-89.5415039-31.7741699c-1.1262207,3.1633301-2.3271484,6.2902832-3.6020508,9.3798828Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-clove",
							className: "outer-panel",
							"data-key": "clove",
							d: "M530.3613281,638.6126099l54.7634277,77.625c4.2324219-2.980957,8.3901367-6.0603027,12.4575195-9.2507324l-58.6987305-74.6933594c-2.7824707,2.1794434-5.626709,4.2832031-8.5222168,6.3190918Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-smokedwood",
							className: "outer-panel",
							"data-key": "smoked_wood",
							d: "M597.9018555,558.5576782l85.9194336,40.5541992c2.1901855-4.621582,4.262207-9.309082,6.2194824-14.0571289l-87.8818359-36.1101074c-1.3398438,3.2468262-2.7578125,6.4526367-4.2570801,9.6130371Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-mushroom",
							className: "outer-panel",
							"data-key": "mushroom",
							d: "M614.0109863,509.0733032l93.3430176,17.6838379c.9558105-5.0664062,1.7854004-10.1767578,2.4831543-15.329834l-94.1264648-12.8393555c-.4775391,3.5246582-1.0454102,7.0200195-1.699707,10.4853516Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-apricots",
							className: "outer-panel",
							"data-key": "apricots",
							d: "M617.4677734,477.6047974c-.1140137,3.4978027-.3151855,6.9731445-.6022949,10.4245605l94.6582031,7.9611816c.4194336-5.0458984.7133789-10.126709.8798828-15.2404785l-94.935791-3.1452637Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-tobacco",
							className: "outer-panel",
							"data-key": "tobacco",
							d: "M611.802002,519.3167114l92.3256836,22.4169922c1.1989746-4.9458008,2.2756348-9.9384766,3.2263184-14.9765625l-93.3430176-17.6838379c-.6508789,3.4458008-1.3879395,6.8608398-2.2089844,10.2434082Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-olive",
							className: "outer-panel",
							"data-key": "olive",
							d: "M615.7106934,498.5879517l94.1264648,12.8393555c.6914062-5.1062012,1.2553711-10.2521973,1.6865234-15.4367676l-94.6582031-7.9611816c-.295166,3.5461426-.6813965,7.065918-1.1547852,10.5585938Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-carob",
							className: "outer-panel",
							"data-key": "carob",
							d: "M593.0566406,568.1289673l83.685791,44.9802246c2.4799805-4.59375,4.8356934-9.2634277,7.0788574-13.9973145l-85.9194336-40.5541992c-1.5354004,3.2368164-3.1477051,6.4301758-4.8452148,9.5712891Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-whisky",
							className: "outer-panel",
							"data-key": "whisky",
							d: "M605.7609863,539.5647583l89.5415039,31.7741699c1.7124023-4.8154297,3.3037109-9.6875,4.7736816-14.612793l-91.0476074-27.1552734c-1.0061035,3.3684082-2.0952148,6.7006836-3.2675781,9.9938965Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-vanillaextract",
							className: "outer-panel",
							"data-key": "vanilla_extract",
							d: "M554.6032715,618.640686l65.9516602,68.3603516c3.8415527-3.6962891,7.5791016-7.4987793,11.2197266-11.3935547l-69.4941406-64.7536621c-2.4914551,2.6618652-5.0483398,5.2609863-7.6772461,7.7868652Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-vanillin",
							className: "outer-panel",
							"data-key": "vanillin",
							d: "M547.0654297,625.5376587l62.4724121,71.5566406c3.7568359-3.2724609,7.4282227-6.6401367,11.0170898-10.0932617l-65.9516602-68.3603516c-2.4555664,2.3596191-4.9672852,4.6608887-7.5378418,6.8969727Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-ginger",
							className: "outer-panel",
							"data-key": "ginger",
							d: "M562.2805176,610.8538208l69.4941406,64.7536621c3.4250488-3.6643066,6.7583008-7.4140625,9.998291-11.246582l-72.6506348-61.1938477c-2.2172852,2.6193848-4.4980469,5.1826172-6.8417969,7.6867676Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-cinnamon",
							className: "outer-panel",
							"data-key": "cinnamon",
							d: "M538.8835449,632.2935181l58.6987305,74.6933594c4.0725098-3.1943359,8.0563965-6.4958496,11.9555664-9.8925781l-62.4724121-71.5566406c-2.6677246,2.3205566-5.3955078,4.5737305-8.1818848,6.7558594Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-blackpepper",
							className: "outer-panel",
							"data-key": "blackpepper",
							d: "M575.682373,595.0054321l75.6767578,57.4157715c3.2607422-4.2805176,6.416748-8.6442871,9.4482422-13.1008301l-78.6591797-53.2714844c-2.074707,3.046875-4.234375,6.0302734-6.4658203,8.956543Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-coriander",
							className: "outer-panel",
							"data-key": "coriander",
							d: "M582.1481934,586.0488892l78.6591797,53.2714844c2.7900391-4.1020508,5.4846191-8.2744141,8.0734863-12.5185547l-81.2067871-49.3115234c-1.7719727,2.9018555-3.6162109,5.7543945-5.5258789,8.5585938Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-nutmeg",
							className: "outer-panel",
							"data-key": "nutmeg",
							d: "M569.1223145,603.1670532l72.6506348,61.1938477c3.2939453-3.8964844,6.4909668-7.876709,9.5861816-11.9396973l-75.6767578-57.4157715c-2.1181641,2.7773438-4.3059082,5.4980469-6.5600586,8.1616211Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-rosemary",
							className: "outer-panel",
							"data-key": "rosemary",
							d: "M587.6740723,577.4902954l81.2067871,49.3115234c2.7373047-4.4875488,5.357666-9.0539551,7.8615723-13.692627l-83.685791-44.9802246c-1.7141113,3.171875-3.5090332,6.2929688-5.3825684,9.3613281Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-figs",
							className: "outer-panel",
							"data-key": "figs",
							d: "M617.592041,470.8042603c0,2.2768555-.0507812,4.5415039-.1242676,6.8005371l94.935791,3.1452637c.107666-3.3037109.1816406-6.6159668.1816406-9.9458008,0-1.9362793-.0366211-3.8637695-.0732422-5.7915039l-94.9702148,1.8276367c.0251465,1.3193359.050293,2.6386719.050293,3.9638672Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-cherry",
							className: "outer-panel",
							"data-key": "cherry",
							d: "M577.5195312,349.0432739l76.526123-56.2807617c-3.0136719-4.0808105-6.1237793-8.0854492-9.3359375-12.0041504l-73.5791016,60.0791016c2.1982422,2.6787109,4.3261719,5.4165039,6.388916,8.2058105Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-raspberry",
							className: "outer-panel",
							"data-key": "raspberry",
							d: "M583.6257324,357.7713013l79.3422852-52.2419434c-2.8674316-4.3349609-5.8398438-8.5935059-8.9223633-12.7668457l-76.526123,56.2807617c2.1096191,2.8530273,4.1437988,5.7644043,6.1062012,8.7280273Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-strawberry",
							className: "outer-panel",
							"data-key": "strawberry",
							d: "M589.237793,366.7420044l81.9296875-48.092041c-2.623291-4.4484863-5.3571777-8.8232422-8.1994629-13.1206055l-79.3422852,52.2419434c1.9455566,2.9379883,3.8164062,5.9291992,5.6120605,8.9707031Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-peach",
							className: "outer-panel",
							"data-key": "peach",
							d: "M594.3481445,375.927063l84.2854004-43.8435059c-2.3762207-4.5483398-4.8671875-9.026123-7.4660645-13.4335938l-81.9296875,48.092041c1.7790527,3.0134277,3.4836426,6.0751953,5.1103516,9.1850586Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-grape",
							className: "outer-panel",
							"data-key": "grape",
							d: "M571.1306152,340.8374634l73.5791016-60.0791016c-3.2258301-3.9355469-6.543457-7.7929688-9.9616699-11.5578613l-70.4350586,63.737793c2.3393555,2.572998,4.6098633,5.2092285,6.817627,7.8991699Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-mandarin",
							className: "outer-panel",
							"data-key": "mandarin",
							d: "M549.4042969,318.1463013l63.5576172-70.5939941c-3.7954102-3.4086914-7.6804199-6.7182617-11.6467285-9.9326172l-59.8791504,73.7404785c2.713623,2.1958008,5.3713379,4.4572754,7.9682617,6.7861328Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-orange",
							className: "outer-panel",
							"data-key": "orange",
							d: "M541.4360352,311.3601685l59.8791504-73.7404785c-4.0029297-3.2436523-8.0910645-6.3850098-12.260498-9.4228516l-56.0063477,76.7263184c2.8522949,2.0749512,5.6491699,4.2209473,8.3876953,6.4370117Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-bergamot",
							className: "outer-panel",
							"data-key": "bergamot",
							d: "M564.3129883,332.9382935l70.4350586-63.737793c-3.4433594-3.7922363-6.9870605-7.4907227-10.6179199-11.1020508l-67.0844727,67.2541504c2.4846191,2.4677734,4.9111328,4.9941406,7.267334,7.5856934Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-tamarind",
							className: "outer-panel",
							"data-key": "tamarind",
							d: "M557.0456543,325.3526001l67.0844727-67.2541504c-3.6306152-3.6108398-7.3579102-7.1237793-11.1682129-10.5461426l-63.5576172,70.5939941c2.6071777,2.3383789,5.1572266,4.7390137,7.6413574,7.2062988Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-dates",
							className: "outer-panel",
							"data-key": "dates",
							d: "M617.541748,466.8403931l94.9702148-1.8276367c-.0961914-5.0808105-.3198242-10.1298828-.6655273-15.1459961l-94.7602539,6.6137695c.2368164,3.4309082.3896484,6.8847656.4555664,10.3598633Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-prunes",
							className: "outer-panel",
							"data-key": "prunes",
							d: "M616.1120605,446.1558228l94.3117676-11.3835449c-.6369629-5.3210449-1.4069824-10.6008301-2.3188477-15.8327637l-93.5803223,16.387207c.6242676,3.5783691,1.1513672,7.1896973,1.5874023,10.8291016Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-raisins",
							className: "outer-panel",
							"data-key": "raisins",
							d: "M617.0861816,456.4805298l94.7602539-6.6137695c-.3496094-5.0673828-.824707-10.0996094-1.4226074-15.0944824l-94.3117676,11.3835449c.409668,3.416748.7348633,6.8586426.9741211,10.324707Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-coconut",
							className: "outer-panel",
							"data-key": "coconut",
							d: "M614.5246582,435.3267212l93.5803223-16.387207c-.8439941-4.8430176-1.8059082-9.6452637-2.8796387-14.4057617l-92.6723633,20.9399414c.7351074,3.2558594,1.3935547,6.5405273,1.9716797,9.8530273Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-lemon",
							className: "outer-panel",
							"data-key": "lemon",
							d: "M533.0483398,304.9231567l56.0063477-76.7263184c-4.1345215-3.0126953-8.3474121-5.9230957-12.6379395-8.7258301l-52.0136719,79.4924316c2.9350586,1.9140625,5.8168945,3.9020996,8.6452637,5.9597168Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-pineapple",
							className: "outer-panel",
							"data-key": "pineapple",
							d: "M606.7277832,404.7893677l89.9907227-30.4995117c-1.5957031-4.6989746-3.3061523-9.3449707-5.1252441-13.9360352l-88.3740234,34.9050293c1.2451172,3.1396484,2.4162598,6.3168945,3.5085449,9.5305176Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-roastedalmond",
							className: "outer-panel",
							"data-key": "roasted_almond",
							d: "M352.5085144,274.7493286l-27.5766602-90.9221191c-4.953125,1.5109863-9.8544922,3.140625-14.6953125,4.8974609l32.2355957,89.3789062c3.3059082-1.203125,6.6533203-2.3188477,10.036377-3.354248Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-banana",
							className: "outer-panel",
							"data-key": "banana",
							d: "M612.5529785,425.4736938l92.6723633-20.9399414c-1.1582031-5.1369629-2.4406738-10.2265625-3.8588867-15.2600098l-91.4553223,25.7629395c.9709473,3.4423828,1.848877,6.9233398,2.6418457,10.4370117Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-mango",
							className: "outer-panel",
							"data-key": "mango",
							d: "M609.9111328,415.0366821l91.4553223-25.7629395c-1.4228516-5.0495605-2.9711914-10.0461426-4.6479492-14.9838867l-89.9907227,30.4995117c1.1479492,3.3769531,2.2094727,6.7937012,3.1833496,10.2473145Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-apple",
							className: "outer-panel",
							"data-key": "apple",
							d: "M598.9814453,385.3633423l86.4211426-39.4799805c-2.1401367-4.6665039-4.3999023-9.2658691-6.769043-13.7998047l-84.2854004,43.8435059c1.621582,3.1003418,3.1682129,6.2453613,4.6333008,9.4362793Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-malty",
							className: "outer-panel",
							"data-key": "malty",
							d: "M412.584198,265.7964478c.6645508,0,1.324707.0187988,1.9880371.0251465l1.2060547-94.9777832c-1.0651855-.0112305-2.1262207-.0405273-3.1940918-.0405273-3.8400879,0-7.6572266.0961914-11.4621582.2392578l3.4350586,94.9248047c2.6643066-.1025391,5.3376465-.1708984,8.0270996-.1708984Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-cereal",
							className: "outer-panel",
							"data-key": "cereal",
							d: "M436.3488464,267.175354l11.2932129-94.3220215c-5.2619629-.6125488-10.5651855-1.0876465-15.9067383-1.4243164l-6.2580566,94.7827148c3.6506348.2265625,7.2751465.5483398,10.871582.963623Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-honey",
							className: "outer-panel",
							"data-key": "honey",
							d: "M393.9203796,266.6509399l-8.3657227-94.6223145c-5.0991211.4553223-10.1611328,1.0378418-15.1835938,1.7453613l13.1757812,94.0791016c3.4313965-.4865723,6.8898926-.8876953,10.3735352-1.2021484Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-sweetpopcorn",
							className: "outer-panel",
							"data-key": "sweet_popcorn",
							d: "M425.4772644,266.211731l6.2580566-94.7827148c-5.2834473-.3330078-10.6030273-.5292969-15.9570312-.5852051l-1.2060547,94.9777832c3.6589355.0349121,7.2941895.1660156,10.9050293.3901367Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-maplesyrup",
							className: "outer-panel",
							"data-key": "maple_syrup",
							d: "M404.5570984,265.9673462l-3.4350586-94.9248047c-5.2246094.1962891-10.4143066.5258789-15.5673828.986084l8.3657227,94.6223145c3.520752-.3178711,7.0668945-.5461426,10.6367188-.6835938Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-toastedbread",
							className: "outer-panel",
							"data-key": "toasted_bread",
							d: "M362.6716003,271.9280396l-22.8598633-92.2172852c-5.0107422,1.2485352-9.9724121,2.6193848-14.8798828,4.1164551l27.5766602,90.9221191c3.3515625-1.0258789,6.7407227-1.9650879,10.1630859-2.8212891Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-classiccaramel",
							className: "outer-panel",
							"data-key": "classic_caramel",
							d: "M373.1435242,269.6021118l-18.0012207-93.2822266c-5.1584473,1.0004883-10.2702637,2.1298828-15.3305664,3.3908691l22.8598633,92.2172852c3.456543-.8647461,6.9482422-1.6391602,10.4719238-2.3259277Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-toffee",
							className: "outer-panel",
							"data-key": "toffee",
							d: "M383.5468445,267.8530884l-13.1757812-94.0791016c-5.1191406.7209473-10.1962891,1.5698242-15.2287598,2.5458984l18.0012207,93.2822266c3.4377441-.6699219,6.90625-1.2531738,10.4033203-1.7490234Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-walnut",
							className: "outer-panel",
							"data-key": "walnut",
							d: "M506.2909851,288.4229126l43.6457825-84.3901367c-4.6037598-2.375-9.2727051-4.6411133-14.0114746-6.7810059l-39.2185059,86.546875c3.2407227,1.4602051,6.4355469,3.003418,9.5842285,4.6242676h-.0000305Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-lime",
							className: "outer-panel",
							"data-key": "lime",
							d: "M524.4030762,298.9634399l52.0136719-79.4924316c-4.3110352-2.8156738-8.6953125-5.5273438-13.15625-8.1235352l-47.8564453,82.0688477c3.0512695,1.7724609,6.050293,3.6245117,8.9990234,5.5471191Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-pecan",
							className: "outer-panel",
							"data-key": "pecan",
							d: "M496.7067566,283.798645l39.2185364-86.546875c-4.6870117-2.1164551-9.4421387-4.1083984-14.2536621-5.9873047l-34.7119141,88.4494629c3.2902832,1.2817383,6.541748,2.640625,9.7470703,4.0847168h-.0000305Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-macadamia",
							className: "outer-panel",
							"data-key": "macadamia",
							d: "M486.9596863,279.7139282l34.7119446-88.4494629c-4.8688965-1.9016113-9.8027344-3.6723633-14.7915039-5.322998l-30.034668,90.1425781c3.411377,1.125,6.784668,2.3330078,10.1142578,3.6298828h-.0000305Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-biscuity",
							className: "outer-panel",
							"data-key": "biscuity",
							d: "M446.0971375,268.5383911l15.8063965-93.6767578c-4.7177734-.7802734-9.472168-1.4506836-14.2614746-2.0083008l-11.2932129,94.3220215c3.2736816.3779297,6.5234375.8327637,9.748291,1.3630371Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-cashew",
							className: "outer-panel",
							"data-key": "cashew",
							d: "M515.4040527,293.4163208l47.8564453-82.0688477c-4.373291-2.5454102-8.8137207-4.9875488-13.3237305-7.3146973l-43.645752,84.3901367c3.0847168,1.5881348,6.1218262,3.2558594,9.1130371,4.9934082Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-hazelnut",
							className: "outer-panel",
							"data-key": "hazelnut",
							d: "M456.8200378,270.597229l20.7700195-92.7094727c-5.1799316-1.1445312-10.4099121-2.1533203-15.6865234-3.026123l-15.8063965,93.6767578c3.6069336.5932617,7.1821289,1.2797852,10.7229004,2.0588379Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-pistachio",
							className: "outer-panel",
							"data-key": "pistachio",
							d: "M466.7289734,273.038147l25.3547363-91.5656738c-4.784668-1.3117676-9.6166992-2.5070801-14.4936523-3.5847168l-20.7700195,92.7094727c3.3344727.7333984,6.6376953,1.5473633,9.9089355,2.440918Z",
							fill: "#e25d2c"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavour-outer-panel-almond",
							className: "outer-panel",
							"data-key": "almond",
							d: "M476.8454285,276.0840454l30.034668-90.1425781c-4.8776855-1.6137695-9.8115234-3.1022949-14.7963867-4.4689941l-25.3547363,91.5656738c3.4084473.9309082,6.7814941,1.9458008,10.1164551,3.0458984Z",
							fill: "#e25d2c"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "flavor-inner",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-unroastedcocoa",
							className: "mini-panel",
							"data-key": "unroasted_cocoa",
							d: "M253.9873047,348.9264221c-2.2099609,2.8601074-4.3398438,5.7900391-6.3898926,8.7800293l-4.1298828-2.8200684c2.0998535-3.0598145,4.2797852-6.0598145,6.5498047-8.9897461l3.9699707,3.0297852Z",
							fill: "#361f1a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-alkali",
							className: "mini-panel",
							"data-key": "alkali",
							d: "M260.5373535,340.8465881c-2.25,2.6398926-4.4399414,5.329834-6.5500488,8.079834l-3.9699707-3.0297852c2.1601562-2.8200684,4.4001465-5.5800781,6.7099609-8.2800293l3.8100586,3.2299805Z",
							fill: "#361f1a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-phenolicbitter",
							className: "mini-panel",
							"data-key": "phenolic_bitter",
							d: "M267.3774414,333.2565002c-2.3500977,2.4699707-4.630127,5-6.8400879,7.5900879l-3.8100586-3.2299805c2.2700195-2.6501465,4.6000977-5.25,7.0200195-7.7800293l3.630127,3.4199219Z",
							fill: "#361f1a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-volatileacidity",
							className: "mini-panel",
							"data-key": "volatile_acidity",
							d: "M274.5874023,326.0265198c-2.4699707,2.3500977-4.869873,4.7600098-7.2099609,7.2299805l-3.630127-3.4199219c2.380127-2.5400391,4.8500977-5.0100098,7.380127-7.4199219l3.4599609,3.6098633Z",
							fill: "#361f1a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-milky",
							className: "mini-panel",
							"data-key": "milky",
							d: "M282.1975098,319.1363831c-2.6000977,2.2302246-5.1401367,4.5302734-7.6101074,6.8901367l-3.4599609-3.6098633c2.5400391-2.420166,5.1398926-4.7802734,7.8000488-7.0600586l3.2700195,3.7797852Z",
							fill: "#4d3026",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-creamy",
							className: "mini-panel",
							"data-key": "creamy",
							d: "M290.1374512,312.646637c-2.7099609,2.0898438-5.3500977,4.2597656-7.9399414,6.4897461l-3.2700195-3.7797852c2.6499023-2.2900391,5.369873-4.5100098,8.1398926-6.6501465l3.0700684,3.9401855Z",
							fill: "#4d3026",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-buttery",
							className: "mini-panel",
							"data-key": "buttery",
							d: "M298.5373535,306.4664612c-2.8598633,1.9899902-5.6599121,4.0500488-8.3999023,6.1801758l-3.0700684-3.9401855c2.8100586-2.1899414,5.6899414-4.3000488,8.619873-6.329834l2.8500977,4.0898438Z",
							fill: "#4d3026",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-yoghurty",
							className: "mini-panel",
							"data-key": "yoghurty",
							d: "M307.2773438,300.7264709c-2.9699707,1.8400879-5.8798828,3.7600098-8.7399902,5.7399902l-2.8500977-4.0898438c2.9301758-2.0400391,5.9001465-4.0100098,8.9401855-5.8901367h.0100098l2.6398926,4.2399902Z",
							fill: "#4d3026",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-roastedcocoa",
							className: "mini-panel",
							"data-key": "roasted_cocoa",
							d: "M316.267334,295.4664612c-3.0498047,1.6801758-6.0498047,3.4301758-8.9899902,5.2600098l-2.6398926-4.2399902c3.0200195-1.869873,6.0898438-3.6699219,9.2099609-5.3798828l2.4199219,4.3598633Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-roastedcoffee",
							className: "mini-panel",
							"data-key": "roasted_coffee",
							d: "M325.057373,290.9064026c-2.9699707,1.4501953-5.8999023,2.9702148-8.7900391,4.5600586l-2.4199219-4.3598633c2.9599609-1.6401367,5.9699707-3.2001953,9.0200195-4.6801758l2.1899414,4.4799805Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-mocha",
							className: "mini-panel",
							"data-key": "mocha",
							d: "M334.8273926,286.4664612c-3.3100586,1.4001465-6.5600586,2.880127-9.7700195,4.4399414l-2.1899414-4.4799805c3.2900391-1.6098633,6.619873-3.1298828,10.0100098-4.5498047h.0100098l1.9399414,4.5898438Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-roastedhazelnut",
							className: "mini-panel",
							"data-key": "roasted_hazelnut",
							d: "M344.1474609,282.8065491c-3.1501465,1.1398926-6.2600098,2.369873-9.3200684,3.6599121l-1.9399414-4.5898438c3.1398926-1.3400879,6.3100586-2.5900879,9.5400391-3.7600098l1.7199707,4.6899414Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-roastedalmond",
							className: "mini-panel",
							"data-key": "roasted_almond",
							d: "M353.9572754,279.5265198c-3.3098145,1.0100098-6.579834,2.1000977-9.8098145,3.2800293l-1.7199707-4.6899414c3.3098145-1.2102051,6.6599121-2.3300781,10.0598145-3.3701172l1.4699707,4.7800293Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-toastedbread",
							className: "mini-panel",
							"data-key": "toasted_bread",
							d: "M363.8474121,276.7765198c-3.3300781.8300781-6.6298828,1.75-9.8901367,2.75l-1.4699707-4.7800293c3.3400879-1.0200195,6.7199707-1.9599609,10.130127-2.8200684l1.2299805,4.8500977Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-classiccaramel",
							className: "mini-panel",
							"data-key": "classic_caramel",
							d: "M374.0974121,274.4964905c-3.4499512.670166-6.8701172,1.4299316-10.25,2.2800293l-1.2299805-4.8500977c3.4699707-.869873,6.9699707-1.6499023,10.5100098-2.329834l.9699707,4.8999023Z",
							fill: "#6b3c2b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-toffee",
							className: "mini-panel",
							"data-key": "toffee",
							d: "M384.1674805,272.8065491c-3.380127.4699707-6.7399902,1.0400391-10.0700684,1.6899414l-.9699707-4.8999023c3.4099121-.670166,6.8498535-1.25,10.3200684-1.7399902l.7199707,4.9499512Z",
							fill: "#6b3c2b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-honey",
							className: "mini-panel",
							"data-key": "honey",
							d: "M394.3874512,271.6166077c-3.4301758.3000488-6.8400879.6999512-10.2199707,1.1899414l-.7199707-4.9499512c3.4599609-.5,6.9599609-.9101562,10.4799805-1.2202148l.4599609,4.9802246Z",
							fill: "#6b3c2b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-maplesyrup",
							className: "mini-panel",
							"data-key": "maple_syrup",
							d: "M404.8173828,270.9564514c-3.5.1201172-6.9699707.3400879-10.4299316.6601562l-.4599609-4.9802246c3.5400391-.3198242,7.1098633-.5498047,10.6999512-.6799316l.1899414,5Z",
							fill: "#6b3c2b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-malty",
							className: "mini-panel",
							"data-key": "malty",
							d: "M414.5473633,265.8065491l-.0500488,5c-.6398926-.0100098-1.2797852-.0100098-1.9199219-.0100098-2.6000977,0-5.1799316.0500488-7.7600098.1599121l-.1899414-5c2.6398926-.1098633,5.2900391-.1599121,7.9499512-.1599121.6599121,0,1.3100586,0,1.9699707.0100098Z",
							fill: "#7a422d",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-almond",
							className: "mini-panel",
							"data-key": "almond",
							d: "M476.8273926,276.0665588l-1.5800781,4.75c-3.2600098-1.0800781-6.5498047-2.0700684-9.8798828-2.9699707l1.3198242-4.8300781c3.420166.9299316,6.8000488,1.9499512,10.1401367,3.0500488Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-macadamia",
							className: "mini-panel",
							"data-key": "macadamia",
							d: "M486.8474121,279.6666565l-1.8200684,4.6599121c-3.2199707-1.2600098-6.4799805-2.4299316-9.7800293-3.5100098l1.5800781-4.75c3.3798828,1.1098633,6.7199707,2.3100586,10.0200195,3.6000977Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-pecan",
							className: "mini-panel",
							"data-key": "pecan",
							d: "M496.6774902,283.7865295l-2.0600586,4.5600586c-3.1601562-1.4299316-6.3500977-2.7700195-9.5900879-4.0200195l1.8200684-4.6599121c3.3200684,1.2897949,6.6000977,2.6599121,9.8300781,4.119873Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-walnut",
							className: "mini-panel",
							"data-key": "walnut",
							d: "M506.2373047,288.3863831l-2.3000488,4.4501953c-3.0598145-1.5800781-6.1699219-3.0800781-9.3198242-4.4899902l2.0600586-4.5600586c3.2299805,1.4499512,6.4199219,2.9899902,9.5598145,4.5998535Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-cashew",
							className: "mini-panel",
							"data-key": "cashew",
							d: "M515.4475098,293.436676l-2.5200195,4.329834c-2.9501953-1.7299805-5.9501953-3.369873-8.9902344-4.9299316l2.3000488-4.4501953c3.1201172,1.6101074,6.1901855,3.2900391,9.2102051,5.050293Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-lime",
							className: "mini-panel",
							"data-key": "lime",
							d: "M524.4772949,299.0065002l-2.7399902,4.1801758c-2.8798828-1.8901367-5.8198242-3.7001953-8.8098145-5.420166l2.5200195-4.329834c3.0598145,1.7797852,6.0698242,3.6298828,9.0297852,5.5698242Z",
							fill: "#984328",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-lemon",
							className: "mini-panel",
							"data-key": "lemon",
							d: "M533.0373535,304.9064026l-2.9499512,4.0302734c-2.7299805-1.9802246-5.5200195-3.9001465-8.3500977-5.75l2.7399902-4.1801758c2.9101562,1.8901367,5.7600098,3.8601074,8.5600586,5.8999023Z",
							fill: "#984328",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-orange",
							className: "mini-panel",
							"data-key": "orange",
							d: "M541.4772949,311.3766174l-3.1599121,3.8798828c-2.6899414-2.1699219-5.4299316-4.2800293-8.2299805-6.3198242l2.9499512-4.0302734c2.8701172,2.0800781,5.6899414,4.2402344,8.4399414,6.4702148Z",
							fill: "#984328",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-mandarin",
							className: "mini-panel",
							"data-key": "mandarin",
							d: "M549.4372559,318.1666565l-3.3498535,3.7197266c-2.5300293-2.2797852-5.119873-4.4897461-7.7700195-6.6298828l3.1599121-3.8798828c2.7202148,2.1999512,5.3701172,4.4599609,7.9599609,6.7900391Z",
							fill: "#984328",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-bergamot",
							className: "mini-panel",
							"data-key": "bergamot",
							d: "M564.2573242,332.8863831l-3.7199707,3.3601074c-2.2700195-2.5200195-4.619873-4.9699707-7.0400391-7.369873l3.5400391-3.5400391c2.4699707,2.4599609,4.880127,4.9799805,7.2199707,7.5498047Z",
							fill: "#984328",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-grape",
							className: "mini-panel",
							"data-key": "grape",
							d: "M571.1074219,340.8065491l-3.880127,3.1599121c-2.1599121-2.6298828-4.3898926-5.2099609-6.6899414-7.7199707l3.7199707-3.3601074c2.3500977,2.5800781,4.630127,5.2202148,6.8500977,7.920166Z",
							fill: "#ad4524",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-cherry",
							className: "mini-panel",
							"data-key": "cherry",
							d: "M577.517334,349.0365295l-4.0400391,2.9599609c-2.0097656-2.7299805-4.0998535-5.4099121-6.25-8.0300293l3.880127-3.1599121c2.1999512,2.6799316,4.3400879,5.4299316,6.4099121,8.2299805Z",
							fill: "#ad4524",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-raspberry",
							className: "mini-panel",
							"data-key": "raspberry",
							d: "M583.6074219,357.7364807l-4.1799316,2.75c-1.9001465-2.8898926-3.8901367-5.7199707-5.9501953-8.4899902l4.0400391-2.9599609c2.1101074,2.8400879,4.1401367,5.75,6.0900879,8.6999512Z",
							fill: "#ad4524",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-strawberry",
							className: "mini-panel",
							"data-key": "strawberry",
							d: "M589.2473145,366.7364807l-4.3198242,2.5200195c-1.7600098-2.9699707-3.5900879-5.8999023-5.5-8.7700195l4.1799316-2.75c1.9599609,2.9501953,3.8400879,5.9501953,5.6398926,9Z",
							fill: "#ad4524",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-peach",
							className: "mini-panel",
							"data-key": "peach",
							d: "M594.3574219,375.936676l-4.4399414,2.2998047c-1.5900879-3.0400391-3.25-6.0300293-4.9899902-8.9799805l4.3198242-2.5200195c1.7800293,3.0200195,3.4799805,6.0800781,5.1101074,9.2001953Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-apple",
							className: "mini-panel",
							"data-key": "apple",
							d: "M598.9973145,385.4166565l-4.5498047,2.0598145c-1.4301758-3.119873-2.9401855-6.2099609-4.5300293-9.2399902l4.4399414-2.2998047c1.6298828,3.1098633,3.1799316,6.2697754,4.6398926,9.4799805Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-pear",
							className: "mini-panel",
							"data-key": "pear",
							d: "M603.2373047,395.3165588l-4.6599121,1.8198242c-1.2900391-3.2597656-2.6699219-6.4799805-4.1298828-9.6599121l4.5498047-2.0598145c1.5100098,3.2597656,2.920166,6.5598145,4.2399902,9.8999023Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-pineapple",
							className: "mini-panel",
							"data-key": "pineapple",
							d: "M606.7072754,404.7565002l-4.7397461,1.5900879c-1.0600586-3.1000977-2.1901855-6.170166-3.3901367-9.2102051l4.6599121-1.8198242c1.2302246,3.1098633,2.3901367,6.2600098,3.4699707,9.4399414Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-mango",
							className: "mini-panel",
							"data-key": "mango",
							d: "M609.9174805,415.0865784l-4.8200684,1.3398438c-.9599609-3.3999023-2-6.7597656-3.1298828-10.079834l4.7397461-1.5900879c1.1601562,3.3999023,2.2299805,6.8500977,3.2102051,10.3300781Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-banana",
							className: "mini-panel",
							"data-key": "banana",
							d: "M612.5473633,425.4664612l-4.8798828,1.0800781c-.7700195-3.4101562-1.630127-6.7800293-2.5700684-10.1201172l4.8200684-1.3398438c.9699707,3.4199219,1.8398438,6.8798828,2.6298828,10.3798828Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-coconut",
							className: "mini-panel",
							"data-key": "coconut",
							d: "M614.517334,435.3165588l-4.9299316.8398438c-.5600586-3.2299805-1.1999512-6.4399414-1.9199219-9.6098633l4.8798828-1.0800781c.7399902,3.25,1.3898926,6.5400391,1.9699707,9.8500977Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-prunes",
							className: "mini-panel",
							"data-key": "prunes",
							d: "M616.1074219,446.1964417l-4.9599609.5800781c-.420166-3.5700684-.9499512-7.1098633-1.5600586-10.6201172l4.9299316-.8398438c.630127,3.5898438,1.1601562,7.2199707,1.5900879,10.8798828Z",
							fill: "#c1562f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-raisins",
							className: "mini-panel",
							"data-key": "raisins",
							d: "M617.0773926,456.4764709l-4.9899902.3300781c-.2199707-3.369873-.5400391-6.7099609-.9399414-10.0300293l4.9599609-.5800781c.4199219,3.4001465.7399902,6.8300781.9699707,10.2800293Z",
							fill: "#c1562f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-dates",
							className: "mini-panel",
							"data-key": "dates",
							d: "M617.5373535,466.9064026l-5,.0700684c-.0600586-3.4099121-.2099609-6.8000488-.4499512-10.1699219l4.9899902-.3300781c.25,3.4499512.3999023,6.9299316.4599609,10.4299316Z",
							fill: "#c1562f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-figs",
							className: "mini-panel",
							"data-key": "figs",
							d: "M617.5773926,470.7965393c0,2.25-.0400391,4.4899902-.1098633,6.7299805l-5-.1899414c.0698242-2.1699219.1098633-4.3500977.1098633-6.5400391,0-1.2800293-.0100098-2.5500488-.0400391-3.8200684l5-.0700684c.0300293,1.2900391.0400391,2.5900879.0400391,3.8901367Z",
							fill: "#c1562f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-blackpepper",
							className: "mini-panel",
							"data-key": "blackpepper",
							d: "M582.1274414,586.0565796c-2.0700684,3.0400391-4.2199707,6.0300293-6.4699707,8.9599609l-3.9599609-3.0400391c2.1799316-2.8498535,4.2797852-5.7700195,6.3098145-8.7399902l4.1201172,2.8200684Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-nutmeg",
							className: "mini-panel",
							"data-key": "nutmeg",
							d: "M575.6574707,595.0165405c-2.1000977,2.7700195-4.2800293,5.4899902-6.5300293,8.1398926l-3.8100586-3.25c2.1999512-2.579834,4.3200684-5.2299805,6.380127-7.9299316l3.9599609,3.0400391Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-ginger",
							className: "mini-panel",
							"data-key": "ginger",
							d: "M569.1274414,603.1564331c-2.2099609,2.6201172-4.4899902,5.170166-6.8300781,7.670166l-3.6398926-3.4299316c2.2900391-2.4401855,4.5100098-4.9301758,6.6599121-7.4902344l3.8100586,3.25Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-vanillaextract",
							className: "mini-panel",
							"data-key": "vanilla_extract",
							d: "M562.2973633,610.8265991c-2.4799805,2.6599121-5.0400391,5.25-7.6699219,7.7800293l-3.4599609-3.6201172c2.5698242-2.4599609,5.0698242-4.9899902,7.4899902-7.5898438l3.6398926,3.4299316Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-vanillin",
							className: "mini-panel",
							"data-key": "vanillin",
							d: "M554.6274414,618.6066284c-2.4699707,2.369873-5,4.6899414-7.5900879,6.9299316l-3.2700195-3.7800293c2.5200195-2.1799316,4.9899902-4.4399414,7.4001465-6.7700195l3.4599609,3.6201172Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-cinnamon",
							className: "mini-panel",
							"data-key": "cinnamon",
							d: "M547.0373535,625.5365601c-2.6699219,2.3300781-5.3999023,4.5900879-8.1899414,6.75l-3.0600586-3.9399414c2.7199707-2.1201172,5.380127-4.3200684,7.9799805-6.5900879l3.2700195,3.7800293Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-clove",
							className: "mini-panel",
							"data-key": "clove",
							d: "M538.8474121,632.2865601c-2.7800293,2.1899414-5.6101074,4.3000488-8.5,6.3200684l-2.8601074-4.1000977c2.8200684-1.9699707,5.5900879-4.0300293,8.3000488-6.1599121l3.0600586,3.9399414Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-liquorice",
							className: "mini-panel",
							"data-key": "liquorice",
							d: "M530.3474121,638.6066284c-2.8901367,2.0400391-5.8300781,4-8.8300781,5.8798828l-2.6499023-4.2399902c2.9199219-1.829834,5.8000488-3.7399902,8.619873-5.7399902l2.8601074,4.1000977Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-jasmine",
							className: "mini-panel",
							"data-key": "jasmine",
							d: "M521.517334,644.4865112c-3.0100098,1.8901367-6.0698242,3.7099609-9.1899414,5.4501953l-2.4199219-4.380127c.5400391-.3000488,1.079834-.6000977,1.6098633-.9099121.5400391-.3100586,1.0800781-.6101074,1.6101074-.9301758.1499023-.0800781.3098145-.1699219.4599609-.2700195.3000488-.1699219.5998535-.3498535.8999023-.5200195.7199707-.4299316,1.4499512-.869873,2.170166-1.3098145.7399902-.4499512,1.4799805-.9101562,2.2099609-1.3701172l2.6499023,4.2399902Z",
							fill: "#747934",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-rose",
							className: "mini-panel",
							"data-key": "rose",
							d: "M503.0773926,654.7865601c-3.1599121,1.5600586-6.3598633,3.0400391-9.6098633,4.4199219l-1.9501953-4.5898438c3.1699219-1.3601074,6.2900391-2.8000488,9.3701172-4.3200684l2.1899414,4.4899902Z",
							fill: "#747934",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-lavender",
							className: "mini-panel",
							"data-key": "lavender",
							d: "M493.4675293,659.2064819c-3.4101562,1.4802246-6.8701172,2.8601074-10.380127,4.1401367l-1.7099609-4.6901855c3.4299316-1.25,6.8000488-2.5998535,10.1298828-4.0397949h.0100098l1.9501953,4.5898438Z",
							fill: "#747934",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-tamarind",
							className: "mini-panel",
							"data-key": "tamarind",
							d: "M557.0373535,325.3365784l-3.5400391,3.5400391c-2.4099121-2.3901367-4.8798828-4.7202148-7.4099121-6.9902344l3.3498535-3.7197266c2.6000977,2.329834,5.130127,4.7197266,7.6000977,7.1699219Z",
							fill: "#984328",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-dairy",
							className: "panel",
							"data-key": "dairy",
							d: "M360.1574707,385.6266174c-1.4799805.9099121-2.9399414,1.8598633-4.3601074,2.8598633-1.4299316.9699707-2.8200684,1.9899902-4.1899414,3.0600586-1.3500977,1.0300293-2.6799316,2.1000977-3.9699707,3.2099609-1.3000488,1.1101074-2.5600586,2.25-3.8000488,3.4199219l-39.4699707-41.1298828-29.7800293-31.0200195c2.4699707-2.3598633,5.0100098-4.6599121,7.6101074-6.8901367,2.5898438-2.2299805,5.2299805-4.3999023,7.9399414-6.4897461,2.7399902-2.130127,5.5400391-4.1901855,8.3999023-6.1801758,2.8601074-1.9799805,5.7700195-3.8999023,8.7399902-5.7399902l22.7299805,36.5100098v.0100098l30.1501465,48.380127Z",
							fill: "#4d3026",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-roasted",
							className: "panel",
							"data-key": "roasted",
							d: "M374.3774414,318.4764709c-2.6101074.6501465-5.1999512,1.3701172-7.7600098,2.1501465-.7299805.2299805-1.4499512.4499512-2.1801758.6899414-1.1499023.3701172-2.2998047.75-3.4499512,1.1599121-.6899414.2299805-1.3798828.4799805-2.0598145.7299805-.6101074.2199707-1.2299805.4499512-1.8400879.6799316-.6101074.2302246-1.2199707.4702148-1.8300781.7102051-1.2099609.4699707-2.4199219.9599609-3.6298828,1.4699707-.5.2099609-.9899902.4199219-1.4899902.6398926-.3000488.1201172-.5900879.25-.8901367.3901367-.2998047.1298828-.5898438.2600098-.8898926.3999023-1.0200195.4499512-2.0400391.920166-3.0600586,1.4099121-.4499512.2102051-.8898926.420166-1.3400879.6401367-2.3198242,1.1401367-4.6298828,2.3200684-6.8898926,3.5700684-.0100098,0-.0100098.0100098-.0200195.0100098-.5900879.329834-1.1899414.6499023-1.7700195.9899902-.5900879.329834-1.1799316.6699219-1.7700195,1.0197754-.6899414.4001465-1.3798828.8100586-2.0700684,1.2302246-.4799805.2897949-.9599609.579834-1.4299316.8798828v-.0100098l-22.7299805-36.5100098c2.9401855-1.829834,5.9401855-3.579834,8.9899902-5.2600098,2.8901367-1.5898438,5.8200684-3.1098633,8.7900391-4.5600586,3.2099609-1.5598145,6.4599609-3.0397949,9.7700195-4.4399414,3.0600586-1.2900391,6.1699219-2.5200195,9.3200684-3.6599121,3.2299805-1.1799316,6.5-2.2700195,9.8098145-3.2800293,3.2602539-1,6.5600586-1.9199219,9.8901367-2.75l10.5300293,41.6999512Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeLinejoin: "round"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-golden",
							className: "panel",
							"data-key": "golden",
							d: "M406.4973145,313.9166565c-.8498535.0297852-1.6799316.0698242-2.5200195.119873-1.0200195.0500488-2.0297852.1101074-3.0400391.1899414-.8798828.0600586-1.75.130127-2.619873.2102051-1.6599121.1499023-3.3200684.329834-4.9599609.5297852-.4001465.0500488-.8000488.1000977-1.1899414.1501465-.6201172.079834-1.2399902.1599121-1.8601074.25-.8000488.1098633-1.6000977.2299805-2.3999023.3598633-.8000488.1201172-1.6101074.2600098-2.4101562.4001465-.5.079834-1,.1699219-1.5.2700195-.5297852.0998535-1.0600586.1999512-1.5898438.2998047-2.0300293.3901367-4.0400391.8200684-6.0400391,1.3000488-.3400879.0800781-.6801758.1599121-1.0100098.2399902-.3300781.0800781-.6501465.1601562-.9799805.2399902l-10.5300293-41.6999512c3.3798828-.8500977,6.8000488-1.6098633,10.25-2.2800293,3.3300781-.6499023,6.6899414-1.2199707,10.0700684-1.6899414,3.3798828-.4899902,6.7897949-.8898926,10.2199707-1.1899414,3.4599609-.3200684,6.9299316-.5400391,10.4299316-.6601562l1.6799316,42.9602051Z",
							fill: "#6b3c2b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-grainsandcereals",
							className: "panel",
							"data-key": "grains_and_cerials",
							d: "M445.2973633,273.4564514l-7.0700684,42.4299316v.0102539c-.6699219-.1201172-1.3498535-.2299805-2.0200195-.3300781-.9599609-.1499023-1.9199219-.2900391-2.8898926-.4101562-.8601074-.119873-1.7299805-.2197266-2.5998535-.3198242-.8400879-.1000977-1.6801758-.1899414-2.5302734-.2700195-1.1699219-.1201172-2.3498535-.2199707-3.5297852-.3100586-.75-.0600586-1.5-.1098633-2.25-.1499023-.3701172-.0300293-.7399902-.0500488-1.1101074-.0700684-.3100586-.0200195-.6398926-.0300293-.9599609-.0500488-1.0600586-.0498047-2.130127-.0898438-3.1999512-.119873-.380127-.0200195-.7700195-.0300293-1.1601562-.0300293-.6298828-.0200195-1.2597656-.0300293-1.8898926-.0300293-.5-.0100098-1.0100098-.0100098-1.5100098-.0100098-1.1899414,0-2.3701172.0100098-3.5500488.0400391-.7600098.0200195-1.5200195.0400391-2.2800293.0698242-.079834,0-.1699219.0102539-.25.0102539l-1.6799316-42.9602051c2.5800781-.1098633,5.1599121-.1599121,7.7600098-.1599121.6401367,0,1.2800293,0,1.9199219.0100098,3.5600586.0300293,7.1000977.1599121,10.6101074.380127,3.5600586.2197266,7.0998535.5297852,10.6101074.9299316,3.2099609.369873,6.4099121.8200684,9.579834,1.3398438Z",
							fill: "#7a422d",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-nutty",
							className: "panel",
							"data-key": "nutty",
							d: "M512.9274902,297.76651l-21.6601562,37.1398926c-1.2800293-.7397461-2.5800781-1.4697266-3.8798828-2.1699219-.5500488-.3100586-1.1000977-.6000977-1.6501465-.8898926-.5100098-.2700195-1.0197754-.5300293-1.5300293-.7900391-2.3999023-1.2399902-4.829834-2.4099121-7.3098145-3.5100098v-.0100098c-.3400879-.1501465-.6799316-.3000488-1.0200195-.4499512s-.6799316-.3100586-1.0200195-.4501953c-.8500977-.369873-1.6999512-.7299805-2.5600586-1.079834-.7099609-.2900391-1.4299316-.5800781-2.1499023-.869873-.25-.1000977-.5100098-.2001953-.7700195-.300293-1.5300293-.5898438-3.0700684-1.1599121-4.630127-1.7099609-.5498047-.1999512-1.0998535-.3898926-1.6499023-.5698242-.4599609-.1601562-.9199219-.3100586-1.3901367-.4599609-2.5498047-.8500977-5.1398926-1.630127-7.75-2.3300781-.6298828-.1801758-1.2597656-.3500977-1.8898926-.5100098-.630127-.170166-1.2600098-.3300781-1.8999023-.4799805-1.2700195-.3100586-2.5400391-.6101074-3.8200684-.8898926-2.6799316-.5900879-5.3901367-1.1101074-8.1201172-1.5400391v-.0102539l7.0700684-42.4299316c3.4799805.5800781,6.9399414,1.2399902,10.3601074,2,3.2700195.7102051,6.5100098,1.5,9.7099609,2.3901367,3.3300781.8999023,6.619873,1.8898926,9.8798828,2.9699707,3.3000488,1.0800781,6.5600586,2.25,9.7800293,3.5100098,3.2399902,1.25,6.4299316,2.5900879,9.5900879,4.0200195,3.1499023,1.4099121,6.2600098,2.9099121,9.3198242,4.4899902,3.0400391,1.5600586,6.0400391,3.1999512,8.9902344,4.9299316Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-citrus",
							className: "panel",
							"data-key": "citrus",
							d: "M560.5373535,336.2464905l-31.9099121,28.8000488c-.9001465-.9799805-1.8100586-1.9499512-2.7299805-2.9101562-.4602051-.4799805-.920166-.9599609-1.3901367-1.4299316-.4699707-.4799805-.9399414-.9499512-1.4199219-1.4199219-1.1699219-1.1699219-2.3500977-2.3100586-3.5600586-3.4299316-.7099609-.6601562-1.4199219-1.3200684-2.1499023-1.9702148-.0300293-.0297852-.0700684-.0598145-.1000977-.0898438-1.9899902-1.7800293-4.0200195-3.5100098-6.0998535-5.1799316-2.1000977-1.6999512-4.2600098-3.3601074-6.4599609-4.9499512-.5400391-.3901367-1.0700684-.7802734-1.6101074-1.1601562-1.0800781-.7600098-2.1799316-1.5200195-3.2800293-2.25-.5500488-.3701172-1.1098633-.7399902-1.6599121-1.1000977-.6999512-.4499512-1.4001465-.8999023-2.1000977-1.3398438-.6899414-.4399414-1.380127-.8701172-2.0800781-1.2900391-.2897949-.1799316-.5898438-.3598633-.8798828-.5300293-.5400391-.329834-1.0900879-.6499023-1.6398926-.9699707-.0700684-.0400391-.130127-.0800781-.2001953-.1201172l21.6601562-37.1398926c2.9899902,1.7199707,5.9299316,3.5300293,8.8098145,5.420166,2.8300781,1.8498535,5.6201172,3.7697754,8.3500977,5.75,2.8000488,2.0397949,5.5400391,4.1499023,8.2299805,6.3198242,2.6501465,2.1401367,5.2399902,4.3500977,7.7700195,6.6298828,2.5300293,2.2700195,5,4.6000977,7.4099121,6.9902344,2.420166,2.3999023,4.7700195,4.8498535,7.0400391,7.369873Z",
							fill: "#984328",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-dried",
							className: "panel",
							"data-key": "dried_fruits",
							d: "M612.5773926,470.7965393c0,2.1899414-.0400391,4.3701172-.1098633,6.5400391-.1101074,3.4599609-.3100586,6.8999023-.5900879,10.3198242l-42.8400879-3.8398438c.0300293-.3000488.0500488-.6101074.0700684-.9101562.079834-.869873.1398926-1.75.1899414-2.6398926v-.0300293c.0500488-.8198242.0900879-1.6499023.130127-2.4799805,0-.0500488,0-.1098633.0097656-.1599121.0200195-.630127.0400391-1.25.0600586-1.880127.0200195-.7399902.0400391-1.4899902.0500488-2.2299805.0200195-.8999023.0300293-1.7900391.0300293-2.6899414,0-.9599609-.0100098-1.9299316-.0300293-2.8901367,0-.1098633,0-.2099609-.0100098-.3198242-.0200195-1.3400879-.0698242-2.6801758-.1298828-4.0100098-.0300293-.670166-.0600586-1.3300781-.1000977-1.9899902-.0400391-.6699219-.0800781-1.3300781-.1298828-1.9899902-.0400391-.6599121-.0900879-1.3200684-.1501465-1.9799805-.0400391-.5300293-.0900879-1.0600586-.1398926-1.5900879-.0800781-.8500977-.1601562-1.6999512-.2600098-2.5500488-.0600586-.5900879-.130127-1.1699219-.1999512-1.75-.0800781-.6999512-.170166-1.3999023-.2700195-2.0998535-.1201172-.9101562-.25-1.8300781-.3901367-2.7402344-.1599121-1.0297852-.3198242-2.0397949-.5-3.0598145-.0200195-.1398926-.0498047-.2900391-.0800781-.4299316h.0102539l42.3898926-7.2402344c.6101074,3.5102539,1.1398926,7.0500488,1.5600586,10.6201172.3999023,3.3200684.7199707,6.6601562.9399414,10.0300293.2399902,3.369873.3898926,6.7600098.4499512,10.1699219.0300293,1.2700195.0400391,2.5400391.0400391,3.8200684Z",
							fill: "#c1562f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-tropicalandyellowfruits",
							className: "panel",
							"data-key": "tropical_and_yellow_fruits",
							d: "M609.5874023,436.1564026l-42.3898926,7.2402344h-.0102539c-.4399414-2.5300293-.9499512-5.0500488-1.5197754-7.5400391-.1801758-.8000488-.3701172-1.6101074-.5600586-2.4101562-.2900391-1.1899414-.6000977-2.3798828-.920166-3.5600586-.1398926-.5297852-.2897949-1.0698242-.4399414-1.5998535-.0297852-.119873-.0698242-.25-.0998535-.369873h-.0100098c-.7399902-2.670166-1.5700684-5.3100586-2.4599609-7.9101562h-.0100098c-.1501465-.4599609-.3100586-.9199219-.4699707-1.3798828-.2102051-.6101074-.4301758-1.2099609-.6501465-1.8100586s-.4399414-1.1999512-.6699219-1.8000488c-.2199707-.5998535-.4499512-1.1899414-.6901855-1.7900391-.0598145-.1499023-.1098633-.2897949-.1699219-.4399414h-.0100098c-.0700684-.1899414-.1499023-.3898926-.2299805-.5800781-.1699219-.4499512-.3498535-.8898926-.5400391-1.329834-.1599121-.4001465-.329834-.8000488-.5-1.1899414-.1398926-.3300781-.2800293-.6601562-.4199219-.9902344-.0900879-.2199707-.1899414-.4399414-.2900391-.6599121-.2700195-.619873-.5400391-1.2399902-.8200684-1.8498535-.1499023-.3300781-.2897949-.6501465-.4399414-.9702148v-.0100098c-.0498047-.0898438-.0898438-.1799316-.1298828-.2697754-.2399902-.5200195-.4799805-1.0302734-.7299805-1.550293-.2900391-.6098633-.5800781-1.2197266-.880127-1.8198242-.2900391-.6000977-.5998535-1.2099609-.8999023-1.8100586-.3100586-.6000977-.6201172-1.1999512-.9299316-1.7900391-.6201172-1.1899414-1.2602539-2.3798828-1.920166-3.5498047-.3200684-.5800781-.6499023-1.170166-.9899902-1.75-.3300781-.5800781-.6699219-1.1601562-1.0200195-1.7299805l.0100098-.0102539,37.1501465-21.6699219c1.7399902,2.9499512,3.3999023,5.9399414,4.9899902,8.9799805,1.5898438,3.0300293,3.0998535,6.1201172,4.5300293,9.2399902,1.4599609,3.1799316,2.8398438,6.4001465,4.1298828,9.6599121,1.1999512,3.0400391,2.3300781,6.1101074,3.3901367,9.2102051,1.1298828,3.3200684,2.1699219,6.6799316,3.1298828,10.079834.9399414,3.3400879,1.8000488,6.7099609,2.5700684,10.1201172.7199707,3.1699219,1.3598633,6.3798828,1.9199219,9.6098633Z",
							fill: "#b64d2a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-redfruits",
							className: "panel",
							"data-key": "red_fruits",
							d: "M584.9274902,369.2565002l-37.1501465,21.6699219-.0100098.0102539c-1.369873-2.3400879-2.8198242-4.630127-4.3198242-6.8901367-.7402344-1.1298828-1.5-2.2399902-2.2800293-3.3500977-.3300781-.4699707-.6601562-.9299316-.9899902-1.3898926-.4599609-.6398926-.920166-1.2800293-1.3901367-1.9099121-.0300293-.0300293-.0500488-.0600586-.0698242-.0900879-.5700684-.7700195-1.1501465-1.5300293-1.7402344-2.2900391-.2998047-.3999023-.6098633-.8000488-.9199219-1.1899414-.3000488-.3898926-.6098633-.7800293-.9299316-1.170166-.4099121-.5200195-.8300781-1.0397949-1.2600098-1.5498047-.4199219-.5100098-.8500977-1.0300293-1.2800293-1.5400391-.0200195-.0300293-.0400391-.0600586-.0700684-.0900879-.8100586-.9499512-1.6298828-1.8999023-2.4599609-2.8400879-.4799805-.5297852-.9499512-1.0598145-1.4299316-1.5898438l31.9099121-28.8000488c2.3000488,2.5100098,4.5300293,5.0900879,6.6899414,7.7199707,2.1501465,2.6201172,4.2402344,5.3000488,6.25,8.0300293,2.0600586,2.7700195,4.0500488,5.6000977,5.9501953,8.4899902,1.9099121,2.8701172,3.7399902,5.8000488,5.5,8.7700195Z",
							fill: "#ad4524",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-floral",
							className: "panel",
							"data-key": "floral",
							d: "M518.8674316,640.246521c-.7299805.4599609-1.4699707.920166-2.2099609,1.3701172-.7202148.4399414-1.4501953.8798828-2.170166,1.3098145-.3000488.170166-.5998535.3500977-.8999023.5200195-.1501465.1000977-.3100586.1899414-.4599609.2700195-.5300293.3200684-1.0700684.6201172-1.6101074.9301758-.5300293.3098145-1.0698242.6098633-1.6098633.9099121-2.9599609,1.6599121-5.9702148,3.2399902-9.0200195,4.7399902-3.0800781,1.5200195-6.2001953,2.9599609-9.3701172,4.3200684h-.0100098c-3.329834,1.4399414-6.6999512,2.7897949-10.1298828,4.0397949l-8.9099121-24.4399414-5.8300781-15.9799805c.7800293-.2900391,1.5498047-.5800781,2.3198242-.8798828.6201172-.2399902,1.2402344-.4799805,1.8500977-.7299805.6201172-.2402344,1.2399902-.4902344,1.8601074-.75.6499023-.2700195,1.3000488-.5400391,1.9499512-.8200684,1.9499512-.8400879,3.869873-1.7199707,5.7700195-2.630127.5300293-.25,1.0698242-.5097656,1.5898438-.7797852l.0100098-.0102539c.5800781-.2797852,1.1501465-.5698242,1.7302246-.8598633.5998535-.3000488,1.1999512-.6000977,1.7897949-.9199219.170166-.0900879.3400879-.1801758.5100098-.2700195.7700195-.3999023,1.5300293-.8200684,2.2900391-1.2399902.25-.1401367.5100098-.2800293.7600098-.420166.5600586-.3098145,1.1101074-.619873,1.6599121-.9399414.5700684-.3300781,1.1501465-.6599121,1.7202148-1.0100098.5200195-.3000488,1.0297852-.6098633,1.5397949-.9199219.0500488-.0200195.1000977-.0500488.1501465-.0900879.5100098-.2998047,1.0100098-.6098633,1.5100098-.9299316.1499023-.0998535.3098145-.1899414.4599609-.2900391l22.7600098,36.5Z",
							fill: "#747934",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-spices",
							className: "panel",
							"data-key": "spices",
							d: "M588.6474609,565.746521c-1.6799316,3.1101074-3.4299316,6.1599121-5.2700195,9.1599121-1.7199707,2.8200684-3.5100098,5.6000977-5.3701172,8.3300781-2.0300293,2.9699707-4.1298828,5.8901367-6.3098145,8.7399902-2.0600586,2.6999512-4.1801758,5.3500977-6.380127,7.9299316-2.1499023,2.5600586-4.369873,5.0500488-6.6599121,7.4902344-2.420166,2.5998535-4.920166,5.1298828-7.4899902,7.5898438-2.4101562,2.3300781-4.880127,4.5900879-7.4001465,6.7700195-2.5998535,2.2700195-5.2600098,4.4699707-7.9799805,6.5900879-2.7099609,2.1298828-5.4799805,4.1899414-8.3000488,6.1599121-2.8198242,2-5.6999512,3.9101562-8.619873,5.7399902l-22.7600098-36.5c2.3000488-1.4499512,4.5600586-2.9499512,6.7800293-4.5100098,2.2099609-1.5600586,4.3798828-3.1799316,6.5100098-4.8500977,1.0700684-.829834,2.119873-1.6899414,3.1699219-2.5498047.3898926-.3200684.7800293-.6401367,1.1599121-.9699707.2099609-.170166.420166-.3500977.630127-.5300293.4399414-.380127.8798828-.75,1.3100586-1.130127,1.0698242-.9299316,2.119873-1.869873,3.1699219-2.829834.3601074-.3400879.7199707-.670166,1.0800781-1.0100098.5197754-.4899902,1.0397949-.9802246,1.5500488-1.4899902,1.1599121-1.0900879,2.2897949-2.2202148,3.4099121-3.3701172.3400879-.3398438.6699219-.6899414,1-1.0300293.5-.5200195.9899902-1.0300293,1.4799805-1.5598145,1.3400879-1.4401855,2.6599121-2.9001465,3.9399414-4.3901367.4299316-.5.8601074-1,1.2800293-1.5.8200684-.9599609,1.6298828-1.9399414,2.4199219-2.9299316.5700684-.7102051,1.1401367-1.4299316,1.7001953-2.1501465.2998047-.3898926.5998535-.7700195.8898926-1.1599121.3100586-.4001465.6101074-.8000488.9099121-1.2099609.3000488-.4001465.6000977-.8100586.9001465-1.2199707,1.0700684-1.4599609,2.119873-2.9399414,3.1398926-4.4399414.5100098-.7602539,1.0200195-1.5302734,1.5300293-2.3000488.5-.7700195.9899902-1.5400391,1.4799805-2.3100586.4099121-.6398926.8100586-1.3000488,1.1999512-1.9499512.1201172-.2001953.2399902-.3901367.3601074-.5900879.3000488-.4799805.579834-.9599609.8601074-1.4399414.0698242-.1000977.1298828-.2099609.1799316-.3100586.2399902-.4099121.4799805-.8100586.7099609-1.2199707.3498535-.6000977.6899414-1.2099609,1.0200195-1.8100586.329834-.5898438.6499023-1.1799316.9699707-1.7700195.0100098-.0200195.0200195-.0297852.0300293-.0498047l37.7700195,20.579834Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-downtoearth",
							className: "panel",
							"data-key": "down_to_earth",
							d: "M611.8774414,487.6564026c-.2900391,3.4702148-.670166,6.9001465-1.1401367,10.3100586v.0100098c-.4599609,3.4299316-1.0100098,6.8300781-1.6398926,10.1901855-.6401367,3.3598633-1.3601074,6.6999207-2.1601562,9.9897156-.8198242,3.3601074-1.7197266,6.6801758-2.6999512,9.9702148-.9799805,3.2998047-2.0500488,6.5600586-3.1999512,9.7797852-1.1000977,3.1000977-2.2800293,6.1601562-3.5200195,9.1801758-1.3100586,3.1599121-2.6999512,6.2900391-4.1599121,9.369873-1.4899902,3.1401367-3.0600586,6.2399902-4.7099609,9.2900391l-37.7700195-20.579834c.0100098-.0200195.0200195-.0302734.0200195-.0500488.3200684-.5800781.6298828-1.170166.9399414-1.7600098.4099121-.7800293.8100586-1.5600586,1.1999512-2.3400879.380127-.7600098.7600098-1.5200195,1.1201172-2.2900391.1398926-.2800293.2700195-.5700684.4099121-.8598633.5800781-1.2102051,1.1398926-2.4299316,1.6699219-3.6601562.2700195-.6098633.5400391-1.2299805.8000488-1.8498535.2700195-.6201172.5400391-1.2399902.7800293-1.8601074.1000977-.2299805.1899414-.4499512.2800293-.6799316.1699219-.3999023.3300781-.8000488.4899902-1.2099609.0100098-.0100098.0100098-.0200195.0100098-.0300293.1799316-.4499512.3598633-.9001465.5300293-1.3500977.0200195-.0598145.0500488-.1098633.0700684-.1699219.1599121-.420166.3198242-.8300781.4699707-1.25.0300293-.0700684.0598145-.1501465.079834-.2199707.1101074-.3100586.2299805-.6101074.3400879-.9199219.1699219-.4602051.3400879-.920166.5-1.380127.0200195-.0700684.0500488-.1398926.0700684-.2099609.329834-.9401855.6499023-1.8701172.9599609-2.8100586.1699219-.4799805.3198242-.9599609.4699707-1.4399414.1899414-.5600586.369873-1.130127.5400391-1.6999512.1398926-.4501953.2700195-.8901367.4099121-1.3400879.0200195-.0600586.0400391-.119873.0500488-.1799316.3999023-1.3400879.7900391-2.7001953,1.1398926-4.0600586.1401367-.5.2700195-1,.4001465-1.5.1999512-.7600098.3898926-1.5200195.5700684-2.2800293.0698242-.2800293.1398926-.5600586.1999512-.8400879.0998535-.3999023.1899414-.7998047.2800293-1.2099609.0498047-.1999512.0898438-.4099121.1298828-.6098633.0800781-.3901367.1799316-.7900391.2600098-1.1801758.1501465-.6599121.2900391-1.329834.4199219-2,.1000977-.4897461.1999512-.9799805.2900391-1.4799805.0400391-.1799316.0700684-.3498535.1000977-.5200195v-.0097656c.0100098-.0400391.0100098-.0800781.0200195-.1201172.119873-.6098633.2299805-1.2199707.329834-1.8400879.1601562-.8798828.3100586-1.7697754.4501953-2.6599121.0898438-.5700684.1699219-1.1401367.25-1.7099609.0297852-.1401367.0498047-.2900391.0598145-.4301758.0600586-.4199219.1101074-.829834.170166-1.2397461.0998535-.670166.1899414-1.3400879.2600098-2.0102539.0598145-.4799805.119873-.9697266.1699219-1.4499512.0500488-.3398438.0800781-.6799316.1101074-1.0100098.0598145-.5297852.1098633-1.0600586.1599121-1.5898438.0700684-.6801758.1298828-1.3601074.1799316-2.0400391l42.8400879,3.8398438v.0000305Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-brown",
							className: "panel",
							"data-key": "brown",
							d: "M491.267334,334.9064026l-28.7299805,49.25c-1.4699707-.8598633-2.9599609-1.6699219-4.4799805-2.4499512-1.5300293-.7800293-3.0800781-1.5197754-4.6499023-2.2199707-1.5700684-.7099609-3.1601562-1.369873-4.7800293-1.9899902-1.6000977-.6298828-3.2199707-1.1999512-4.8601074-1.7399902-1.619873-.5300293-3.2600098-1.0300293-4.9199219-1.4699707-1.6000977-.4399414-3.2099609-.8300781-4.8400879-1.1799316-1.6999512-.380127-3.4199219-.7099609-5.1499023-.9899902-1.5800781-.2600098-3.170166-.4802246-4.7700195-.6601562-1.7399902-.1999512-3.5-.3598633-5.2700195-.4599609-1.75-.119873-3.5100098-.1799316-5.2800293-.1899414-.3198242-.0100098-.6398926-.0100098-.9599609-.0100098-1.2900391,0-2.5800781.0200195-3.8598633.0800781-1.7402344.0600586-3.4702148.1699219-5.1901855.329834-1.7099609.1501465-3.4099121.3400879-5.0900879.5800781v.0100098c-1.6799316.2299805-3.3498535.5100098-5.0097656.8300781-1.7099609.329834-3.4101562.7099609-5.1000977,1.1298828-1.6599121.4101562-3.3000488.8701172-4.9199219,1.3701172-1.6501465.4899902-3.2800293,1.0400391-4.880127,1.6298828-1.5700684.5600586-3.1098633,1.1601562-4.6398926,1.8100586-1.6501465.6799316-3.2700195,1.4199219-4.8701172,2.1999512-1.4799805.7099609-2.9399414,1.4599609-4.3798828,2.25-1.5200195.8300781-3.0100098,1.6999512-4.4799805,2.6101074l-30.1501465-48.380127c.4699707-.3000488.9499512-.5900879,1.4299316-.8798828.6901855-.420166,1.380127-.8300781,2.0700684-1.2302246.5900879-.3498535,1.1799316-.6899414,1.7700195-1.0197754.5800781-.3400879,1.1799316-.6601562,1.7700195-.9899902.0100098,0,.0100098-.0100098.0200195-.0100098,2.2600098-1.25,4.5700684-2.4299316,6.8898926-3.5700684.4501953-.2199707.8901367-.4299316,1.3400879-.6401367,1.0200195-.4897461,2.0400391-.9599609,3.0600586-1.4099121.3000488-.1398926.5900879-.2700195.8898926-.3999023.3000488-.1401367.5900879-.2700195.8901367-.3901367.5-.2199707.9899902-.4299316,1.4899902-.6398926,1.2099609-.5100098,2.4199219-1,3.6298828-1.4699707.6101074-.2399902,1.2199707-.4799805,1.8300781-.7102051.6101074-.2299805,1.2299805-.4599609,1.8400879-.6799316.6799316-.25,1.369873-.5,2.0598145-.7299805,1.1501465-.4099121,2.3000488-.7897949,3.4499512-1.1599121.7302246-.2399902,1.4501953-.4599609,2.1801758-.6899414,2.5600586-.7800293,5.1499023-1.5,7.7600098-2.1501465.329834-.079834.6499023-.1599121.9799805-.2399902.329834-.0800781.6699219-.1599121,1.0100098-.2399902,2-.4799805,4.0100098-.9099121,6.0400391-1.3000488.5297852-.0998535,1.0600586-.1999512,1.5898438-.2998047.5-.1000977,1-.1901855,1.5-.2700195.8000488-.1401367,1.6000977-.2700195,2.4101562-.4001465.7998047-.1298828,1.5998535-.25,2.3999023-.3598633.6201172-.0900879,1.2399902-.170166,1.8601074-.25.3898926-.0500488.7897949-.1000977,1.1899414-.1501465,1.6398926-.1999512,3.3000488-.3798828,4.9599609-.5297852.869873-.0800781,1.7399902-.1501465,2.619873-.2102051,1.0102539-.079834,2.0200195-.1398926,3.0400391-.1899414.8400879-.0500488,1.670166-.0900879,2.5200195-.119873.0800781,0,.170166-.0102539.25-.0102539.7600098-.0297852,1.5200195-.0498047,2.2800293-.0698242,1.1799316-.0300293,2.3601074-.0400391,3.5500488-.0400391.5,0,1.0100098,0,1.5100098.0100098.630127,0,1.2600098.0100098,1.8898926.0300293.3901367,0,.7800293.0100098,1.1601562.0300293,1.0698242.0300293,2.1398926.0700684,3.1999512.119873.3200684.0200195.6499023.0300293.9599609.0500488.3701172.0200195.7399902.0400391,1.1101074.0700684.75.0400391,1.5.0898438,2.25.1499023,1.1799316.0900879,2.3598633.1899414,3.5297852.3100586.8500977.0800781,1.6901855.1699219,2.5302734.2700195.869873.1000977,1.7397461.1999512,2.5998535.3198242.9699707.1201172,1.9299316.2602539,2.8898926.4101562.670166.1000977,1.3500977.2099609,2.0200195.3300781,2.7299805.4299316,5.4401855.9499512,8.1201172,1.5400391,1.2800293.2797852,2.5500488.579834,3.8200684.8898926.6398926.1499023,1.2697754.3098145,1.8999023.4799805.630127.1599121,1.2600098.329834,1.8898926.5100098,2.6101074.6999512,5.2001953,1.4799805,7.75,2.3300781.4702148.1499023.9301758.2998047,1.3901367.4599609.5500488.1799316,1.1000977.369873,1.6499023.5698242,1.5600586.5500488,3.1000977,1.1201172,4.630127,1.7099609.2600098.1000977.5200195.2001953.7700195.300293.7199707.2897949,1.4399414.579834,2.1499023.869873.8601074.3498535,1.7099609.7099609,2.5600586,1.079834.3400879.1401367.6799316.300293,1.0200195.4501953s.6799316.2998047,1.0200195.4499512v.0100098c2.4799805,1.1000977,4.9099121,2.2700195,7.3098145,3.5100098.5102539.2600098,1.0200195.5200195,1.5300293.7900391.5500488.2897949,1.1000977.579834,1.6501465.8898926,1.2998047.7001953,2.5998535,1.4301758,3.8798828,2.1699219Z",
							fill: "#5c3629",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-fruity",
							className: "panel",
							"data-key": "fruity",
							d: "M569.5773926,470.7965393c0,.8999023-.0100098,1.7900391-.0300293,2.6899414-.0100098.7399902-.0300293,1.4899902-.0500488,2.2299805-.0200195.630127-.0400391,1.25-.0600586,1.880127-.0097656.0500488-.0097656.1098633-.0097656.1599121-.0400391.8300781-.0800781,1.6601562-.130127,2.4799805v.0300293c-.0500488.8898926-.1101074,1.7700195-.1899414,2.6398926-.0200195.3000488-.0400391.6101074-.0700684.9101562l-56.7800293-5.0900879c.1401367-1.7099609.2399902-3.4299316.2800293-5.1599121.0300293-.9199219.0400391-1.8400879.0400391-2.7700195,0-.8100586-.0100098-1.6098633-.0300293-2.4101562-.0400391-1.699707-.119873-3.3999023-.25-5.079834-.119873-1.6799316-.2900391-3.3500977-.4899902-5.0100098-.2299805-1.7800293-.4899902-3.5500488-.8100586-5.3000488-.2900391-1.619873-.619873-3.2099609-.9799805-4.8000488-.3999023-1.6999512-.8300781-3.3798828-1.3100586-5.0498047-.4897461-1.6901855-1.0097656-3.3701172-1.5898438-5.0200195-.5300293-1.5500488-1.1000977-3.0800781-1.7199707-4.5900879-.6401367-1.630127-1.3400879-3.2299805-2.0800781-4.8100586-.7099609-1.5598145-1.4799805-3.0900879-2.2800293-4.5998535-.7900391-1.5200195-1.6298828-3.0100098-2.5100098-4.4702148-.8798828-1.4799805-1.8000488-2.9299316-2.7600098-4.3598633-.9499512-1.4299316-1.9399414-2.8400879-2.9799805-4.2199707-1.0100098-1.3601074-2.0600586-2.6999512-3.1298828-4-1.0900879-1.3100586-2.2001953-2.5800781-3.3500977-3.8300781-1.1398926-1.25-2.3200684-2.4799805-3.5300293-3.6499023-1.1999512-1.1999512-2.4399414-2.3601074-3.6999512-3.4699707-1.2600098-1.1401367-2.5600586-2.2402344-3.8798828-3.2900391-1.3400879-1.0900879-2.7102051-2.1401367-4.1101074-3.130127-1.3601074-1-2.75-1.9499512-4.1599121-2.8598633-1.4401855-.9401855-2.9001465-1.8400879-4.3901367-2.6901855l28.7299805-49.25c.0700684.0400391.130127.0800781.2001953.1201172.5498047.3200684,1.0998535.6401367,1.6398926.9699707.2900391.170166.5900879.3500977.8798828.5300293.6999512.4199219,1.3901367.8500977,2.0800781,1.2900391.6999512.4399414,1.4001465.8898926,2.1000977,1.3398438.5500488.3601074,1.1098633.7299805,1.6599121,1.1000977,1.1000977.7299805,2.1999512,1.4899902,3.2800293,2.25.5400391.3798828,1.0700684.7700195,1.6101074,1.1601562,2.1999512,1.5898438,4.3598633,3.25,6.4599609,4.9499512,2.079834,1.6699219,4.1098633,3.3999023,6.0998535,5.1799316.0300293.0300293.0700684.0600586.1000977.0898438.7299805.6501465,1.4399414,1.3100586,2.1499023,1.9702148,1.2099609,1.119873,2.3901367,2.2600098,3.5600586,3.4299316.4799805.4699707.9499512.9399414,1.4199219,1.4199219.4699707.4699707.9299316.9499512,1.3901367,1.4299316.9199219.9602051,1.829834,1.9301758,2.7299805,2.9101562.4799805.5300293.9499512,1.0600586,1.4299316,1.5898438.8300781.9401855,1.6499023,1.8901367,2.4599609,2.8400879.0300293.0300293.0500488.0600586.0700684.0900879.4299316.5100098.8601074,1.0300293,1.2800293,1.5400391.4299316.5100098.8500977,1.0297852,1.2600098,1.5498047.3200684.3901367.6298828.7802734.9299316,1.170166.3100586.3898926.6201172.7900391.9199219,1.1899414.5900879.7600098,1.170166,1.5200195,1.7402344,2.2900391.0197754.0300293.0397949.0600586.0698242.0900879.4699707.6298828.9301758,1.2700195,1.3901367,1.9099121.329834.4599609.6599121.9199219.9899902,1.3898926.7800293,1.1101074,1.5397949,2.2202148,2.2800293,3.3500977,1.5,2.2600098,2.9499512,4.5500488,4.3198242,6.8901367.3500977.5698242.6899414,1.1499023,1.0200195,1.7299805.3400879.579834.6699219,1.1699219.9899902,1.75.6599121,1.1699219,1.3000488,2.3598633,1.920166,3.5498047.3098145.5900879.619873,1.1899414.9299316,1.7900391.3000488.6000977.6098633,1.2099609.8999023,1.8100586.3000488.6000977.5900879,1.2099609.880127,1.8198242.25.5200195.4899902,1.0302734.7299805,1.550293.0400391.0898438.0800781.1799316.1298828.2697754v.0100098c.1501465.3200684.2900391.6401367.4399414.9702148.2800293.6098633.5500488,1.2299805.8200684,1.8498535.1000977.2199707.1999512.4399414.2900391.6599121.1398926.3300781.2800293.6601562.4199219.9902344.170166.3898926.3400879.7897949.5,1.1899414.1901855.4399414.3701172.8798828.5400391,1.329834.0800781.1901855.1599121.3901367.2299805.5800781h.0100098c.0600586.1501465.1101074.2900391.1699219.4399414.2402344.6000977.4702148,1.1901855.6901855,1.7900391.2299805.6000977.4499512,1.1999512.6699219,1.8000488s.4399414,1.1999512.6501465,1.8100586c.1599121.4599609.3198242.9199219.4699707,1.3798828h.0100098c.8898926,2.6000977,1.7199707,5.2399902,2.4599609,7.9101562h.0100098c.0300293.119873.0700684.25.0998535.369873.1501465.5300293.3000488,1.0700684.4399414,1.5998535.3200684,1.1801758.630127,2.3701172.920166,3.5600586.1899414.8000488.3798828,1.6101074.5600586,2.4101562.5698242,2.4899902,1.079834,5.0100098,1.5197754,7.5400391.0302734.1398926.0600586.2900391.0800781.4299316.1801758,1.0200195.3400879,2.0300293.5,3.0598145.1401367.9101562.2700195,1.8300781.3901367,2.7402344.0998535.6999512.1899414,1.3999023.2700195,2.0998535.0698242.5800781.1398926,1.1599121.1999512,1.75.0998535.8500977.1799316,1.6999512.2600098,2.5500488.0498047.5300293.0998535,1.0600586.1398926,1.5900879.0600586.6599121.1101074,1.3200684.1501465,1.9799805.0498047.6599121.0898438,1.3200684.1298828,1.9899902.0400391.6599121.0700684,1.3198242.1000977,1.9899902.0600586,1.329834.1098633,2.6699219.1298828,4.0100098.0100098.1098633.0100098.2099609.0100098.3198242.0200195.9602051.0300293,1.9301758.0300293,2.8901367Z",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-cocoa",
							className: "panel",
							"data-key": "cocoa",
							d: "M343.8374023,398.1764221c-1.2299805,1.1601562-2.4299316,2.3601074-3.6000977,3.5900879-1.1799316,1.2299805-2.3198242,2.4899902-3.4199219,3.7800293-1.1398926,1.3000488-2.2299805,2.6401367-3.2800293,4-1.1499023,1.4799805-2.2600098,3-3.3300781,4.5500488l-38-25.9401855-9.0898438-6.1999512-14.0400391-9.5898438-21.4799805-14.6601562c2.0500488-2.9899902,4.1799316-5.9199219,6.3898926-8.7800293,2.1101074-2.75,4.3000488-5.4399414,6.5500488-8.079834,2.2099609-2.5900879,4.4899902-5.1201172,6.8400879-7.5900879,2.3400879-2.4699707,4.7399902-4.8798828,7.2099609-7.2299805l29.7800293,31.0200195,39.4699707,41.1298828Z",
							fill: "#361f1a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-sweetpopcorn",
							className: "mini-panel",
							"data-key": "sweet_popcorn",
							d: "M425.4274902,266.1964417l-.3200684,4.9902344c-3.5100098-.2202148-7.0500488-.3500977-10.6101074-.380127l.0500488-5c3.6501465.0300293,7.2800293.1599121,10.880127.3898926Z",
							fill: "#7a422d",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-cereal",
							className: "mini-panel",
							"data-key": "cereal",
							d: "M436.2973633,267.1564026l-.579834,4.9602051c-3.5102539-.4001465-7.0500488-.7102051-10.6101074-.9299316l.3200684-4.9902344c3.6499023.2202148,7.2700195.5400391,10.869873.9599609Z",
							fill: "#7a422d",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-biscuity",
							className: "mini-panel",
							"data-key": "biscuity",
							d: "M446.1174316,268.5365295l-.8200684,4.9199219c-3.1699219-.5197754-6.369873-.9699707-9.579834-1.3398438l.579834-4.9602051c3.3000488.380127,6.5700684.8400879,9.8200684,1.380127Z",
							fill: "#7a422d",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-hazelnut",
							className: "mini-panel",
							"data-key": "hazelnut",
							d: "M456.7373047,270.5665588l-1.079834,4.8898926c-3.420166-.7600098-6.880127-1.4199219-10.3601074-2l.8200684-4.9199219c3.5698242.5800781,7.1098633,1.2600098,10.619873,2.0300293Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-pistachio",
							className: "mini-panel",
							"data-key": "pistachio",
							d: "M466.6872559,273.01651l-1.3198242,4.8300781c-3.1999512-.8901367-6.4399414-1.6799316-9.7099609-2.3901367l1.079834-4.8898926c3.3500977.7299805,6.670166,1.5500488,9.9499512,2.4499512Z",
							fill: "#884930",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-apricots",
							className: "mini-panel",
							"data-key": "apricots",
							d: "M617.4675293,477.5265198c-.1101074,3.5500488-.3200684,7.0800781-.6101074,10.5800781l-4.9799805-.4501953c.2800293-3.4199219.4799805-6.8598633.5900879-10.3198242l5,.1899414Z",
							fill: "#c1562f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-olive",
							className: "mini-panel",
							"data-key": "olive",
							d: "M616.8574219,488.1065979c-.3000488,3.5498047-.6799316,7.0698242-1.1599121,10.5698242l-4.9602051-.6999512v-.0100098c.4699707-3.4099121.8500977-6.8398438,1.1401367-10.3100586l4.9799805.4501953Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-mushroom",
							className: "mini-panel",
							"data-key": "mushroom",
							d: "M615.6975098,498.6764221c-.4799805,3.5102539-1.0400391,7-1.6901855,10.4501953l-4.9099121-.9599609c.6298828-3.3601074,1.1799316-6.7602539,1.6398926-10.1901855l4.9602051.6999512Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-tobacco",
							className: "mini-panel",
							"data-key": "tobacco",
							d: "M614.0073242,509.1266174c-.6599121,3.4399109-1.3898926,6.849823-2.2199707,10.22995l-4.8500977-1.2001953c.8000488-3.2897949,1.5200195-6.6298828,2.1601562-9.9897461l4.9099121.9599609v.0000305Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-rummy",
							className: "mini-panel",
							"data-key": "rummy",
							d: "M611.7873535,519.3566284c-.8300781,3.4499512-1.7600098,6.8598633-2.7600098,10.2299805l-4.7900391-1.4599609c.9802246-3.2900391,1.880127-6.6101074,2.6999512-9.9702148l4.8500977,1.2001953Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-whisky",
							className: "mini-panel",
							"data-key": "whisky",
							d: "M609.0273438,529.5866089c-1.0100098,3.3798828-2.1098633,6.7199707-3.2900391,10.0200195l-4.6999512-1.7001953c1.1499023-3.2197266,2.2199707-6.4799805,3.1999512-9.7797852l4.7900391,1.4599609Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-woodyoak",
							className: "mini-panel",
							"data-key": "woody_oak",
							d: "M605.7373047,539.6066284c-1.119873,3.1699219-2.329834,6.3100586-3.6098633,9.3999023l-4.6101074-1.9199219c1.2399902-3.0200195,2.4199219-6.0800781,3.5200195-9.1801758l4.6999512,1.7001953Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-smokedwood",
							className: "mini-panel",
							"data-key": "smoked_wood",
							d: "M602.1274414,549.0065308c-1.3400879,3.25-2.7600098,6.4499512-4.2600098,9.6101074l-4.5100098-2.1601562c1.4599609-3.079834,2.8498535-6.2099609,4.1599121-9.369873l4.6101074,1.9199219Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-carob",
							className: "mini-panel",
							"data-key": "carob",
							d: "M597.8674316,558.6166382c-1.5300293,3.2199707-3.1401367,6.3999023-4.8400879,9.5197754l-4.3798828-2.3898926c1.6499023-3.0500488,3.2199707-6.1499023,4.7099609-9.2900391l4.5100098,2.1601562Z",
							fill: "#4f5622",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-rosemary",
							className: "mini-panel",
							"data-key": "rosemary",
							d: "M593.0273438,568.1364136c-1.7099609,3.1801758-3.5100098,6.3100586-5.3898926,9.3901367l-4.2600098-2.6201172c1.8400879-3,3.5900879-6.0498047,5.2700195-9.1599121l4.3798828,2.3898926Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-coriander",
							className: "mini-panel",
							"data-key": "coriander",
							d: "M587.6374512,577.5265503c-1.7700195,2.8901367-3.6000977,5.7399902-5.5100098,8.5300293l-4.1201172-2.8200684c1.8601074-2.7299805,3.6501465-5.5100098,5.3701172-8.3300781l4.2600098,2.6201172Z",
							fill: "#63682b",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-panel-botanical",
							className: "panel",
							"data-key": "botanical",
							d: "M569.0373535,483.8165588c-.0500488.6799316-.1098633,1.3598633-.1799316,2.0400391-.0500488.5297852-.1000977,1.0600586-.1599121,1.5898438-.0300293.3300781-.0600586.670166-.1101074,1.0100098-.0500488.4802246-.1101074.9699707-.1699219,1.4499512-.0700684.670166-.1601562,1.3400879-.2600098,2.0102539-.0600586.4099121-.1101074.8198242-.170166,1.2397461-.0100098.1401367-.0300293.2900391-.0598145.4301758-.0800781.5698242-.1601562,1.1398926-.25,1.7099609-.1401367.8901367-.2900391,1.7800293-.4501953,2.6599121-.0998535.6201172-.2099609,1.2302246-.329834,1.8400879-.0100098.0400391-.0100098.0800781-.0200195.1201172v.0097656c-.0300293.170166-.0600586.3400879-.1000977.5200195-.0900879.5-.1899414.9902344-.2900391,1.4799805-.1298828.670166-.2697754,1.3400879-.4199219,2-.0800781.3901367-.1799316.7900391-.2600098,1.1801758-.0400391.1999512-.0800781.4099121-.1298828.6098633-.0900879.4101562-.1801758.8100586-.2800293,1.2099609-.0600586.2800293-.130127.5600586-.1999512.8400879-.1801758.7600098-.3701172,1.5200195-.5700684,2.2800293-.130127.5-.2600098,1-.4001465,1.5-.3498535,1.3598328-.7399902,2.7199402-1.1398926,4.0600281-.0100098.0600586-.0300293.119873-.0500488.1799316-.1398926.4499512-.2700195.8898926-.4099121,1.3400879-.170166.5698242-.3500977,1.1398926-.5400391,1.6999512-.1501465.4799805-.3000488.9599609-.4699707,1.4399414-.3100586.9399414-.630127,1.869873-.9599609,2.8100586-.0200195.0700684-.0500488.1398926-.0700684.2099609-.1599121.4599609-.3300781.9199219-.5,1.380127-.1101074.3098145-.2299805.6098633-.3400879.9199219-.0200195.0698242-.0498047.1499023-.079834.2199707-.1501465.4199219-.3100586.829834-.4699707,1.25-.0200195.0600586-.0500488.1101074-.0700684.1699219-.170166.4499512-.3500977.9001465-.5300293,1.3500977,0,.0100098,0,.0200195-.0100098.0300293-.1599121.4099121-.3200684.8100586-.4899902,1.2099609-.0900879.2299805-.1799316.4499512-.2800293.6799316-.2399902.6201172-.5100098,1.2399902-.7800293,1.8601074-.2600098.619873-.5300293,1.2399902-.8000488,1.8498535-.5300293,1.2302246-1.0898438,2.4499512-1.6699219,3.6601562-.1398926.2897949-.2700195.579834-.4099121.8598633-.3701172.7700195-.7399902,1.5300293-1.1201172,2.2900391-.3898926.7800293-.7900391,1.5600586-1.1999512,2.3400879-.3100586.5898438-.619873,1.1799316-.9399414,1.7600098,0,.0197754-.0100098.0300293-.0200195.0500488s-.0200195.0297852-.0300293.0498047c-.3200684.5900879-.6401367,1.1801758-.9699707,1.7700195-.3300781.6000977-.670166,1.2099609-1.0200195,1.8100586-.2299805.4099121-.4699707.8100586-.7099609,1.2199707-.0500488.1000977-.1101074.2099609-.1799316.3100586-.2802734.4799805-.5700684.9599609-.8601074,1.4399414-.1201172.1999512-.2399902.3898926-.3601074.5900879-.3898926.6499023-.7900391,1.3100586-1.1999512,1.9499512-.4899902.7700195-.9799805,1.5400391-1.4799805,2.3100586-.5100098.7697754-1.0200195,1.5397949-1.5300293,2.3000488-1.0200195,1.5-2.0698242,2.9799805-3.1398926,4.4399414-.3000488.4099121-.6000977.8198242-.9001465,1.2199707-.2998047.4099121-.5998535.8098145-.9099121,1.2099609-.2900391.3898926-.5900879.7700195-.8898926,1.1599121-.5600586.7202148-1.130127,1.4399414-1.7001953,2.1501465-.7900391.9899902-1.5998535,1.9699707-2.4199219,2.9299316-.4199219.5-.8500977,1-1.2800293,1.5-1.2800293,1.4899902-2.5998535,2.9499512-3.9399414,4.3901367-.4899902.5297852-.9799805,1.0397949-1.4799805,1.5598145-.3300781.3400879-.6599121.6901855-1,1.0300293-1.1201172,1.1499023-2.25,2.2800293-3.4099121,3.3701172-.5102539.5097656-1.0302734,1-1.5500488,1.4899902-.3601074.3398438-.7199707.6699219-1.0800781,1.0100098-1.0500488.9599609-2.1000977,1.8999023-3.1699219,2.829834-.4301758.380127-.8701172.75-1.3100586,1.130127-.2099609.1799316-.420166.3598633-.630127.5300293-.3798828.329834-.7700195.6499023-1.1599121.9699707-1.0500488.8598633-2.0998535,1.7199707-3.1699219,2.5498047-2.130127,1.670166-4.3000488,3.2900391-6.5100098,4.8500977-2.2199707,1.5600586-4.4799805,3.0600586-6.7800293,4.5100098-.1501465.1000977-.3100586.1901855-.4599609.2900391-.5.3200684-1,.630127-1.5100098.9299316-.0500488.0400391-.1000977.0700684-.1501465.0900879-.5100098.3100586-1.0197754.619873-1.5397949.9199219-.5700684.3500977-1.1501465.6799316-1.7202148,1.0100098-.5498047.3200684-1.0998535.630127-1.6599121.9399414-.25.1401367-.5100098.2800293-.7600098.420166-.7600098.4199219-1.5200195.8400879-2.2900391,1.2399902-.1699219.0898438-.3398438.1799316-.5100098.2700195-.5898438.3198242-1.1899414.619873-1.7897949.9199219-.5800781.2900391-1.1501465.5800781-1.7302246.8598633l-.0100098.0102539c-.5297852.2700195-1.0598145.5297852-1.5898438.7797852-1.9001465.9101562-3.8200684,1.7900391-5.7700195,2.630127-.6499023.2800293-1.3000488.5500488-1.9499512.8200684-.6201172.2597656-1.2399902.5097656-1.8601074.75-.6098633.25-1.2299805.4899902-1.8500977.7299805-.7700195.2998047-1.5397949.5898438-2.3198242.8798828l-3.7600098-10.3300781h-.0100098l-15.7600098-43.2397461c1.7299805-.6401367,3.4399414-1.3200684,5.119873-2.0400391,1.5900879-.6899414,3.1601562-1.420166,4.7001953-2.1899414,1.5297852-.75,3.0297852-1.550293,4.5200195-2.380127,1.5200195-.8601074,3.0297852-1.75,4.5-2.6799316,1.4699707-.9301758,2.9099121-1.9001465,4.3198242-2.9001465,1.4101562-.9899902,2.8000488-2.0300293,4.1501465-3.0998535,1.3598633-1.0700684,2.6999512-2.170166,4-3.3200684,1.2600098-1.1000977,2.5-2.2399902,3.6999512-3.4099121,1.2800293-1.2402344,2.5400391-2.5102539,3.75-3.8200684,1.1398926-1.2299805,2.25-2.4899902,3.3198242-3.7700195,1.1000977-1.3000488,2.1601562-2.630127,3.1901855-3.9899902,1.0900879-1.4399414,2.1398926-2.8999023,3.1398926-4.3999023.9301758-1.3701172,1.8200684-2.7602539,2.6801758-4.1801758.9099121-1.5100098,1.7797852-3.0400391,2.6098633-4.6000977.8300781-1.5297852,1.6101074-3.0898438,2.3500977-4.6699219.7199707-1.5400391,1.4099121-3.1098633,2.0600586-4.6999512.619873-1.5200195,1.1999512-3.0600586,1.7397461-4.6101074.5700684-1.6098633,1.1000977-3.25,1.5800781-4.8999023.4899902-1.6499023.9301758-3.3100586,1.3300781-5,.3898926-1.6499023.75-3.3198242,1.0500488-5.0100098.3198242-1.6799316.579834-3.3798828.8000488-5.0998535.2299805-1.7099609.4099121-3.4301758.5397949-5.170166l56.7800293,5.0900879v.0000305Z",
							fill: "#98a147",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "flavor-mini-violet",
							className: "mini-panel",
							"data-key": "violet",
							d: "M512.3273926,649.9367065c-3.0400391,1.6899414-6.1201172,3.3098145-9.25,4.8498535l-2.1899414-4.4899902c3.0498047-1.5,6.0600586-3.0800781,9.0200195-4.7399902l2.4199219,4.380127Z",
							fill: "#747934",
							stroke: "#fff",
							strokeMiterlimit: 10
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "mouthfeel-taste",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "mouthfeel-taste-outer",
					className: "panel-mouthfeel-taste-outer",
					d: "M528.307373,787.3966675c-36.0898438,13.1999512-75.0700684,20.3999023-115.7299805,20.3999023-44.6201172,0-87.2099609-8.6699219-126.1899414-24.4299316-123.6000977-49.9401855-210.8100586-171.0700684-210.8100586-312.5700684,0-70.6201172,21.7199707-136.1699219,58.8599854-190.3300781l30.5699463,20.8601074c-33.0799561,48.2199707-52.4299316,106.579834-52.4299316,169.4699707,0,125.9499512,77.6000977,233.7600098,187.6098633,278.2299805,34.7102051,14.0400391,72.6501465,21.7700195,112.3901367,21.7700195,36.2099609,0,70.9199219-6.4199219,103.0600586-18.1699219l12.6699219,34.7700195Z",
					fill: "#98a147"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "mouthfeel",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-outer",
							className: "panel-mouthfeel-outer",
							d: "M313.9772949,714.6867065l-13.7900391,34.3398438c-110.0097656-44.4699707-187.6098633-152.2800293-187.6098633-278.2299805,0-62.8901367,19.3499756-121.25,52.4299316-169.4699707l30.5500488,20.8601074c-29.0100098,42.2797852-45.9799805,93.4697266-45.9799805,148.6098633,0,110.3798828,68,204.8798828,164.3999023,243.8901367Z",
							fill: "#622a3a"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-trigeminal",
							className: "panel",
							"data-key": "trigeminal",
							d: "M292.2072754,388.1564026c-11.2998047,16.420166-19.329834,35.2802734-23.1298828,55.6201172l-27.5700684-4.8901367c4.5-24.329834,14.0700684-46.8798828,27.5700684-66.5197754l14.0400391,9.5898438,9.0898438,6.1999512Z",
							fill: "#633742",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-texture",
							className: "panel",
							"data-key": "texture",
							d: "M357.5974121,606.0866089l-4.1000977,10.2199707-6.3398438,15.7700195c-63.6801758-25.8500977-108.5800781-88.3200684-108.5800781-161.2800293,0-10.8999023,1-21.5600586,2.9299316-31.9101562l27.5700684,4.8901367c-1.6499023,8.75-2.5,17.7900391-2.5,27.0200195,0,61.1799316,37.6401367,113.5800781,91.0200195,135.2900391Z",
							fill: "#835c5c",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-inner",
							className: "panel-mouthfeel-inner",
							d: "M412.2272949,470.0865784l-37.4699707,93.2997742-17.1599121,42.7001953c-53.3798828-21.7099609-91.0200195-74.1101074-91.0200195-135.2900391,0-30.6799316,9.4599609-59.1499023,25.6298828-82.6401367l38,25.9401855,82.0200195,55.9899902v.0000305Z",
							fill: "#622a3a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-pungent",
							className: "panel",
							"data-key": "pungent",
							d: "M269.0773926,372.3666077c-3.3500977,4.869873-6.4499512,9.9199219-9.3000488,15.1398926l-78.5598145-41.8701172c4.3798828-8.079834,9.1699219-15.9099121,14.3398438-23.449707l28.9199219,19.7397461,18.9902344,12.9599609,4.1298828,2.8200684,21.4799805,14.6601562Z",
							fill: "#633742",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-astringent",
							className: "panel",
							"data-key": "astringent",
							d: "M259.7773438,387.5065002c-2.8999023,5.3100586-5.5400391,10.8000488-7.8798828,16.4301758l-82.5100098-33.4301758v-.0100098c3.5100098-8.5300293,7.4699707-16.8200684,11.8300781-24.8601074l78.5598145,41.8701172Z",
							fill: "#6b4048",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-warm",
							className: "panel",
							"data-key": "warm",
							d: "M251.8974609,403.936676v.0097656c-2.3400879,5.5900879-4.380127,11.3200684-6.1201172,17.1899414l-85.5599365-24.6398926c2.6099854-8.869873,5.6700439-17.5400391,9.1700439-25.9899902l82.5100098,33.4301758Z",
							fill: "#73494f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-cool",
							className: "panel",
							"data-key": "cool",
							d: "M245.7773438,421.1363831c-1.7299805,5.800293-3.1599121,11.7202148-4.2700195,17.75l-87.6499023-15.5598145c1.6499023-9.1201172,3.7800293-18.0700684,6.3599854-26.8300781l85.5599365,24.6398926Z",
							fill: "#7b5356",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-waxy",
							className: "panel",
							"data-key": "waxy",
							d: "M241.5073242,438.8863831c-1.1098633,5.9401855-1.9099121,11.9902344-2.3898926,18.1201172l-88.7800293-6.3100586c.6999512-9.2700195,1.8800049-18.3999023,3.5200195-27.369873l87.6499023,15.5598145Z",
							fill: "#835c5c",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-mouthcoating",
							className: "panel",
							"data-key": "mouthcoating",
							d: "M238.5773926,470.7965393c0,1.4399414.0200195,2.8701172.0600586,4.3000488l-88.960083,2.9099121c-.0699463-2.3898926-.0999756-4.8000488-.0999756-7.2099609,0-6.7600098.2600098-13.4699707.7600098-20.1000977l88.7800293,6.3100586c-.3601074,4.5500488-.5400391,9.1499023-.5400391,13.7900391Z",
							fill: "#8b6563",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-sticky",
							className: "panel",
							"data-key": "sticky",
							d: "M286.7473145,590.9664917l-64.119873,61.7299805c-6.3701172-6.6499023-12.4001465-13.6398926-18.0600586-20.9399414l70.2099609-54.6899414c3.75,4.8398438,7.7399902,9.4799805,11.9699707,13.8999023Z",
							fill: "#c2a591",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-soft",
							className: "panel",
							"data-key": "soft",
							d: "M300.0974121,603.5465698l-57.3100586,68.1000977c-7.0500488-5.9599609-13.7800293-12.2900391-20.1599121-18.9501953l64.119873-61.7299805c4.2202148,4.4301758,8.6801758,8.630127,13.3500977,12.5800781Z",
							fill: "#caae98",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-chewy",
							className: "panel",
							"data-key": "chewy",
							d: "M314.7072754,614.6764526l-49.8798828,73.7202148c-7.6499023-5.2001953-15-10.7900391-22.0400391-16.75l57.3100586-68.1000977c4.6599121,3.9699707,9.5400391,7.6799316,14.6098633,11.1298828Z",
							fill: "#d2b79f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-brittle",
							className: "panel",
							"data-key": "brittle",
							d: "M330.4074707,624.2064819l-41.9101562,78.5300293c-8.1599121-4.369873-16.0600586-9.1599121-23.6699219-14.3398438l49.8798828-73.7202148c5.0500488,3.4501953,10.2900391,6.630127,15.7001953,9.5300293Z",
							fill: "#dac0a5",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-hard",
							className: "panel",
							"data-key": "hard",
							d: "M347.1574707,632.0765991l-9.6899414,24.1398926-1.8601074,4.6401367-8.5800781,21.3398438-13.0500488,32.4902344c-8.7399902-3.5400391-17.2399902-7.5302734-25.4799805-11.9501953l41.9101562-78.5300293c5.4099121,2.9101562,11.0100098,5.5400391,16.75,7.8701172Z",
							fill: "#e2caac",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-creamy",
							className: "panel",
							"data-key": "creamy",
							d: "M240.0473633,493.436676l-88.1699219,12.2597656c-1.2099609-9.0898438-1.9500732-18.329834-2.2000732-27.6899414l88.960083-2.9099121c.1398926,6.1999512.619873,12.3200684,1.4099121,18.3400879Z",
							fill: "#936e6a",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-fatty",
							className: "panel",
							"data-key": "fatty",
							d: "M243.3474121,511.4264221l-86.4100342,21.4101257c-2.1500244-8.880127-3.8399658-17.9301758-5.0599365-27.1401367l88.1699219-12.2597656c.7800293,6.0998535,1.8898926,12.1098633,3.3000488,17.9897461v.0000305Z",
							fill: "#9b7770",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-dry",
							className: "panel",
							"data-key": "dry",
							d: "M248.5373535,528.9765015l-83.6899414,30.3300781c-3.0900879-8.619873-5.7299805-17.4499512-7.9100342-26.4699707l86.4100342-21.4101562c1.4299316,5.9799805,3.1599121,11.8300781,5.1899414,17.5500488Z",
							fill: "#a38077",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-coarse",
							className: "panel",
							"data-key": "coarse",
							d: "M255.5673828,545.8966675l-80.0600586,38.8999023c-3.9899902-8.2700195-7.5499268-16.7700195-10.6599121-25.4899902l83.6899414-30.3300781c2.0500488,5.7900391,4.3999023,11.4299316,7.0300293,16.920166Z",
							fill: "#ab8a7e",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-powdery",
							className: "panel",
							"data-key": "powdery",
							d: "M264.3574219,561.9765015l-75.5600586,47.0600586c-4.8400879-7.8200684-9.2800293-15.9099121-13.2900391-24.2399902l80.0600586-38.8999023c2.6501465,5.5297852,5.5800781,10.8999023,8.7900391,16.079834Z",
							fill: "#b29384",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "mouthfeel-panel-melting",
							className: "panel",
							"data-key": "melting",
							d: "M274.7773438,577.0665894l-70.2099609,54.6899414c-5.6398926-7.2800293-10.9099121-14.8598633-15.7700195-22.7199707l75.5600586-47.0600586c3.2099609,5.2199707,6.6899414,10.25,10.4199219,15.0900879Z",
							fill: "#ba9c8b",
							stroke: "#fff",
							strokeMiterlimit: 10
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "taste",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "taste-panel-outer",
							className: "panel-taste-outer",
							d: "M515.6374512,752.6266479c-32.1401367,11.75-66.8500977,18.1699219-103.0600586,18.1699219-39.7399902,0-77.6799316-7.7299805-112.3901367-21.7700195l13.7900391-34.3398438,13.0500488-32.4902344c10.25,4.1601562,20.8701172,7.5800781,31.8000488,10.2299805,11.2800293,2.7202148,22.8798828,4.6101074,34.75,5.5900879,6.2600098.5200195,12.6000977.7800293,19,.7800293,5,0,9.9699707-.1601562,14.8901367-.4799805,11.079834-.7099609,21.9499512-2.2199707,32.5498047-4.4599609,10.6101074-2.25,20.9399414-5.2299805,30.9501953-8.9001465l11.9897461,32.9001465,12.6801758,34.7700195Z",
							fill: "#e7be42"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "taste-panel-inner",
							className: "panel-taste-inner",
							d: "M451.9174805,577.8666382c-.3601074.1398926-.7199707.2800293-1.0800781.4099121-12.3200684,4.5500488-25.6398926,7.0200195-39.5400391,7.0200195-14.8798828,0-29.0900879-2.8400879-42.119873-8.0100098l5.579834-13.9001465,37.4699707-93.2998047.5300293.3598633h.0100098l34.3400879,94.2202148,4.8100586,13.1999512Z",
							fill: "#e7be42",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "taste-panel-bitter",
							className: "panel",
							"data-key": "bitter",
							d: "M427.4675293,698.3165894c-4.920166.3198242-9.8901367.4799805-14.8901367.4799805-6.3999023,0-12.7399902-.2600098-19-.7800293l9.4499512-113.0200195c2.7299805.1999512,5.4899902.3000488,8.2700195.3000488,2.9399414,0,5.8601074-.1098633,8.75-.3400879l7.420166,113.3601074Z",
							fill: "#c5a23f",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "taste-panel-sweet",
							className: "panel",
							"data-key": "sweet",
							d: "M490.9675293,684.9564819c-10.0102539,3.670166-20.3400879,6.6501465-30.9501953,8.9001465l-23.6699219-111.3100586c4.9599609-1.1000977,9.8000488-2.5300293,14.4899902-4.2700195.3601074-.1298828.7199707-.2700195,1.0800781-.4099121l10.9499512,30.0397949h.0100098l3.7600098,10.3300781,5.8300781,15.9799805,8.9099121,24.4399414,1.7099609,4.6901855,7.880127,21.6098633Z",
							fill: "#b28e2e",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "taste-panel-umami",
							className: "panel",
							"data-key": "umami",
							d: "M385.517334,582.3666382l-26.6899414,110.0598145c-10.9299316-2.6499023-21.5500488-6.0698242-31.8000488-10.2299805l8.5800781-21.3398438,1.8601074-4.6401367,9.6899414-24.1398926,6.3398438-15.7700195,4.1000977-10.2199707,11.5800781-28.8000488c5.2700195,2.0900879,10.7199707,3.8000488,16.3398438,5.0800781Z",
							fill: "#d8b550",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "taste-panel-salty",
							className: "panel",
							"data-key": "salty",
							d: "M403.0273438,584.996521l-9.4499512,113.0200195c-11.8701172-.9799805-23.4699707-2.869873-34.75-5.5900879l26.6899414-110.0598145c5.6801758,1.3200684,11.5300293,2.2099609,17.5100098,2.6298828Z",
							fill: "#ceab48",
							stroke: "#fff",
							strokeMiterlimit: 10
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "taste-panel-sour",
							className: "panel",
							"data-key": "sour",
							d: "M460.017334,693.8566284c-10.5998535,2.2399902-21.4699707,3.75-32.5498047,4.4599609l-7.420166-113.3601074c5.5500488-.4099121,11-1.2199707,16.3000488-2.4099121l23.6699219,111.3100586Z",
							fill: "#bb9837",
							stroke: "#fff",
							strokeMiterlimit: 10
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "center",
			children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				id: "center-background",
				d: "M407.981781,484.8199158c5.4004822,1.6151123,10.9388428.1047974,14.6854248-3.4815674h0c3.7397461-3.5935059,5.4801025-9.0639038,4.0920105-14.5271606s-5.5523987-9.5328979-10.5892029-11.044342h0c-5.0394592-1.5020752-10.6719666-.3623047-14.6843567,3.4858093s-5.3864441,9.4281006-4.0962524,14.5259094h0c1.2996826,5.0955505,5.1918335,9.426239,10.5923157,11.0413513h.000061Z",
				fill: "#e25d2c"
			}), /* @__PURE__ */ _jsx("path", {
				id: "center-foreground",
				d: "M407.981781,484.8199158c5.4004822,1.6151123,10.9388428.1047974,14.6854248-3.4815674h0c3.7397461-3.5935059,5.4801025-9.0639038,4.0920105-14.5271606s-5.5523987-9.5328979-10.5892029-11.044342h0c-5.0394592-1.5020752-10.6719666-.3623047-14.6843567,3.4858093s-5.3864441,9.4281006-4.0962524,14.5259094h0c1.2996826,5.0955505,5.1918335,9.426239,10.5923157,11.0413513h.000061ZM399.1744385,473.3551025l-.0013428.0003052c-.5644836-2.2303162-.5480652-4.5655823.0455627-6.7657776.1226501-.4356079.2545166-.8223877.3767395-1.1604004.3395386-.9388733,1.2795105-2.424469,3.1295776-2.923584,1.9661865-.5304565,3.6352234.0358276,5.1447754,1.6711121,1.7983398,1.9480896,1.3860474,3.9936218.0669556,5.1082153-1.2157898,1.0273132-2.8418884,1.1267395-4.0994873.01474-1.1590881-1.0248718-.946167-2.4438782-.8632812-2.865448.0081787-.041626-.0418091-.0696411-.0726013-.0408325-.1027222.0960693-.2773132.2594299-.4190979.4951477-.5228577.8692322-.5906067,2.3435669.6857605,3.674408,1.3422852,1.3995667,3.9729614,1.8935852,6.1175232-.1631775,2.414856-2.315979,1.4611511-5.1105042.3666382-6.5614624-.791626-1.0494385-1.504425-1.5918274-2.1829834-2.1127014-.7990112-.6133118-1.3466187-1.0907898-1.4216309-1.8748779-.071167-.743866.3586426-1.5866699,1.3663635-2.0807495.1982727-.097229.425293-.1797485.6149902-.2412415,2.4809265-.7442627,5.1451721-.7398682,7.6435242.0037842l.0003662-.0013428c2.2036133.6612549,4.2168579,1.880188,5.8337708,3.5298157.317627.3310547.5885925.6448669.8219299.9252014.6482544.778656,1.4789429,2.3598328,1.0152893,4.2210388-.4927673,1.9779968-1.7908936,3.1326599-3.9370728,3.5975952-2.5567322.553894-4.127533-.8587341-4.4536133-2.5771484-.3005676-1.5838623.4006348-3.0446777,1.9719238-3.5611877,1.4481812-.4760132,2.5732422.4405518,2.8979797.7298889.032074.0285645.0805054-.0003052.0704956-.0418701-.0334167-.1386108-.0903015-.3742371-.225647-.6187134-.499176-.9016418-1.7424622-1.7209473-3.512207-1.3011169-1.8611755.4415283-3.5623169,2.467041-2.8204041,5.387085.8354187,3.2880249,3.7157898,3.9029846,5.5014954,3.7027283,1.2915649-.1448364,2.1060486-.4828796,2.8854065-.8023987.9176331-.3762207,1.5960083-.6045837,2.3109741-.2651062.6782532.322052,1.199646,1.129425,1.1394043,2.2578125-.0118408.2220154-.0503235.4613953-.0889282.6575623-.5568848,2.5344849-1.8505249,4.8416748-3.7036743,6.6236877l.0009766.0010071h0c-1.6391296,1.5690613-3.6687927,2.6853943-5.8793335,3.2359619-.4403076.1045532-.8430786.1775208-1.1986694.235199-.9877625.1602173-2.7584534.0646057-4.1448364-1.2974548-1.4734192-1.4475403-1.8443298-3.1684875-1.2077026-5.2687073.7583618-2.5019836,2.7414856-3.1348572,4.3866577-2.5310364,1.5163269.5565491,2.4412537,1.9179688,2.127594,3.5464478-.289093,1.500885-1.6270752,2.0032959-2.0346985,2.1355591-.0402527.0130615-.0386963.0699463.0021057.0827026.1361389.0425415.3676147.1148071.6447449.1235657,1.0220337.0324097,2.3330383-.6226196,2.8264465-2.373291.5188904-1.8411255-.4106445-4.3606262-3.2971497-5.223877-3.2502441-.9720459-5.1769714,1.2075195-5.8681335,2.8587341-.4999084,1.1942749-.6016541,2.0747375-.7023926,2.9151001-.1186523.9895325-.2493896,1.6953735-.8893433,2.1400146-.6071167.4217834-1.5582886.4572449-2.5057678-.177063-.1864319-.1248169-.3749695-.2816467-.526062-.4163208-1.9240112-1.7902222-3.2946167-4.1018066-3.9398193-6.6275024l-.0000916-.0000305Z",
				fill: "#fff"
			})] })
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "outer",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "outer-velvet",
					className: "outer-tastedimension",
					"data-key": "velvet",
					children: [/* @__PURE__ */ _jsxs("g", {
						className: "outer-tastedimension-title",
						children: [
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(296.3228325 90.917087) rotate(-15.8277816)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0114865em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "V"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(314.4175076 85.8050529) rotate(-13.172807)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "E"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(331.4255341 81.8441052) rotate(-10.7334678)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0179781em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "L"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(345.0824552 79.188572) rotate(-8.484719)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0114865em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "V"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(363.6854078 76.4307834) rotate(-5.8327948)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "E"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(381.0657016 74.6760212) rotate(-3.4031455)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "T"
									})
								})
							})
						]
					}), /* @__PURE__ */ _jsx("g", {
						id: "outer-velvet-line",
						children: /* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "outer-tastedimension-line",
								d: "M637.4941406,151.7376099c-24.592041-17.5117188-51.3754883-32.2526855-79.9326172-43.7282715-34.7651367-13.9702148-72.1550293-23.1054688-111.421875-26.4953613-65.671875-5.6696777-128.9289551,5.3791504-185.579834,29.6044922-6.166748,2.6369629-12.255127,5.4296875-18.2597656,8.3745117-35.9329834,17.6228027-68.8664551,40.6750488-97.6427002,68.1831055-18.362793,17.5537109-35.0311279,36.9216309-49.7056885,57.8496094",
								fill: "none",
								stroke: "#b28e2e",
								strokeMiterlimit: 10
							}),
							/* @__PURE__ */ _jsx("path", { d: "M639.4807129,148.5845337c1.6984863,1.1940918,2.1071777,3.5397949.9130859,5.2382812-1.1940918,1.6982422-3.5397949,2.1071777-5.2380371.9128418-1.6984863-1.1940918-2.1074219-3.5395508-.9130859-5.2380371,1.1940918-1.6982422,3.5397949-2.1071777,5.2380371-.9130859Z" }),
							/* @__PURE__ */ _jsx("path", { d: "M92.0815201,243.2088013c-1.2200928,1.6796875-.847168,4.0314941.8326416,5.2514648,1.6799316,1.2199707,4.0314941.847168,5.2515869-.8327637,1.2199707-1.6796875.847168-4.03125-.8326416-5.2514648-1.6799316-1.2199707-4.0314941-.847168-5.2515869.8327637Z" })
						] })
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "outer-silky",
					className: "outer-tastedimension",
					"data-key": "silky",
					children: [/* @__PURE__ */ _jsxs("g", {
						className: "outer-tastedimension-title",
						children: [
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(154.4680544 232.7572219) rotate(-45.8162254)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "S"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(166.8762612 220.1302053) rotate(-43.828556)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "I"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(172.523695 214.6289406) rotate(-41.7881309)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0179781em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "L"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(184.3567015 204.0106267) rotate(-38.9636096)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "K"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(198.9025167 192.2620639) rotate(-35.9764857)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0214951em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "Y"
									})
								})
							})
						]
					}), /* @__PURE__ */ _jsx("g", {
						id: "outer-silky-line",
						children: /* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "outer-tastedimension-line",
								d: "M130.6172943,272.7776489c12.8865967-18.3305664,27.508667-35.2998047,43.6070557-50.6889648,24.5286865-23.4477539,52.4814453-43.2258301,82.9367828-58.5585938",
								fill: "none",
								stroke: "#916d43",
								strokeMiterlimit: 10
							}),
							/* @__PURE__ */ _jsx("path", { d: "M133.8299408,274.8777466c-1.2200928,1.6796875-3.5716553,2.0527344-5.2515869.8325195-1.6798096-1.2199707-2.0527344-3.5715332-.8326416-5.2514648s3.5716553-2.0527344,5.2514648-.8327637c1.6799316,1.2202148,2.0527344,3.5717773.8327637,5.251709Z" }),
							/* @__PURE__ */ _jsx("path", { d: "M258.7382507,167.0037231c1.8459473-.9501953,2.5727539-3.2175293,1.6225586-5.0637207-.9499512-1.8459473-3.2172852-2.5725098-5.0634766-1.6225586-1.8459473.9501953-2.5725098,3.2175293-1.6225586,5.0634766.9499512,1.8461914,3.2175293,2.5727539,5.0634766,1.6228027Z" })
						] })
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "outer-rustic",
					className: "outer-tastedimension",
					"data-key": "rustic",
					children: [/* @__PURE__ */ _jsxs("g", {
						className: "outer-tastedimension-title",
						children: [
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(813.2546121 519.9155245) rotate(97.8552779)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "R"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(810.8458676 537.6175466) rotate(100.6432033)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "U"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(807.2222634 556.8526919) rotate(103.2617107)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "S"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(803.1507388 574.0425895) rotate(105.7013845)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "T"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(798.80132 589.2856838) rotate(107.4322963)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "I"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(796.536089 596.8472651) rotate(109.4577865)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "C"
									})
								})
							})
						]
					}), /* @__PURE__ */ _jsx("g", {
						id: "outer-rustic-line",
						children: /* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "outer-tastedimension-line",
								d: "M808.5908203,451.9143677c1.050293,18.3876953.8034668,37.0742188-.8269043,55.9609375-1.1586914,13.4189453-2.9885254,26.6188965-5.4516602,39.5698242-8.7080078,45.7883301-25.3486328,88.4631348-48.3334961,126.6977539",
								fill: "none",
								stroke: "#3e2a24",
								strokeMiterlimit: 10
							}),
							/* @__PURE__ */ _jsx("path", { d: "M804.7929688,452.2832642c-.0981445-2.0737305,1.5041504-3.8352051,3.5778809-3.9333496,2.0737305-.0979004,3.8352051,1.5041504,3.9333496,3.578125.0981445,2.0737305-1.5041504,3.8349609-3.5778809,3.9331055-2.0739746.0981445-3.8352051-1.5039062-3.9333496-3.5778809Z" }),
							/* @__PURE__ */ _jsx("path", { d: "M750.7722168,672.0532837c-1.0463867,1.7932129-.440918,4.0959473,1.3522949,5.142334,1.7929688,1.0463867,4.0957031.440918,5.1420898-1.3522949,1.0466309-1.7929688.440918-4.0957031-1.3520508-5.1420898-1.7932129-1.0466309-4.0959473-.4411621-5.142334,1.3520508Z" })
						] })
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "outer-botanical",
					className: "outer-tastedimension",
					"data-key": "botanical",
					children: [/* @__PURE__ */ _jsxs("g", {
						className: "outer-tastedimension-title",
						children: [
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(618.5996654 747.8288167) rotate(-38.116761)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "B"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(633.0721 736.5299467) rotate(-41.5300339)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "O"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(648.9842026 722.3432026) rotate(-44.6555022)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "T"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(659.278712 712.2767514) rotate(-47.3898041)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "A"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(672.4838071 697.9368886) rotate(-50.8146562)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "N"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(685.4517322 681.8076929) rotate(-53.2606335)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "I"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(690.3098786 675.4983132) rotate(-55.6372226)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "C"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(701.4747288 659.1532283) rotate(-58.9828631)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "A"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(711.4641318 642.4366274) rotate(-62.0308989)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0179781em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "L"
									})
								})
							})
						]
					}), /* @__PURE__ */ _jsx("g", {
						id: "outer-botanical-line",
						children: /* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "outer-tastedimension-line",
								d: "M540.0805664,798.0947876c107.4150391-40.8789062,190.2907715-134.6445312,213.8977051-252.0947266",
								fill: "none",
								stroke: "#4f5622",
								strokeMiterlimit: 10
							}),
							/* @__PURE__ */ _jsx("path", { d: "M541.6015625,801.4959106c-1.9362793.7495117-4.1140137-.2128906-4.8632812-2.1491699-.7495117-1.9360352.2128906-4.1140137,2.1491699-4.8632812,1.9360352-.7495117,4.1140137.2128906,4.8632812,2.1491699.7495117,1.9360352-.2128906,4.1140137-2.1491699,4.8632812Z" }),
							/* @__PURE__ */ _jsx("path", { d: "M757.5817871,546.9370728c.421875-2.032959-.8845215-4.0234375-2.9172363-4.4453125-2.032959-.421875-4.0234375.8845215-4.4453125,2.9172363-.421875,2.032959.8845215,4.0234375,2.9172363,4.4453125,2.032959.421875,4.0234375-.8845215,4.4453125-2.9172363Z" })
						] })
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "outer-zestina",
					className: "outer-tastedimension",
					"data-key": "zestina",
					children: [/* @__PURE__ */ _jsxs("g", {
						className: "outer-tastedimension-title",
						children: [
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(693.5197935 253.7534511) rotate(53.1444335)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "Z"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(703.6526735 267.2638997) rotate(55.9504557)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "E"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(713.4306309 281.7286789) rotate(58.8298316)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "S"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(722.5630239 296.8681568) rotate(61.576286)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "T"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(730.064046 310.8756891) rotate(63.526868)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "I"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(733.6935789 317.8758572) rotate(65.867035)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "N"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								isolation: "isolate",
								children: /* @__PURE__ */ _jsx("text", {
									transform: "translate(742.1002047 336.6949025) rotate(69.1585171)",
									fontFamily: "MarkPro-Bold, 'Mark Pro'",
									fontSize: 26.1006203,
									fontWeight: 700,
									isolation: "isolate",
									letterSpacing: "-.0134882em",
									children: /* @__PURE__ */ _jsx("tspan", {
										x: 0,
										y: 0,
										children: "A"
									})
								})
							})
						]
					}), /* @__PURE__ */ _jsx("g", {
						id: "outer-zestina-line",
						children: /* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "outer-tastedimension-line",
								d: "M760.6037598,442.8950806c-7.7348633-100.6103516-59.5432129-190.4924316-137.5-248.345459",
								fill: "none",
								stroke: "#a23a1d",
								strokeMiterlimit: 10
							}),
							/* @__PURE__ */ _jsx("path", { d: "M764.3044434,442.40802c.166748,2.0695801-1.3762207,3.8830566-3.4455566,4.0498047-2.0693359.1669922-3.8828125-1.3759766-4.0498047-3.4455566-.166748-2.0693359,1.3759766-3.8828125,3.4455566-4.0495605,2.0693359-.1669922,3.8828125,1.3759766,4.0498047,3.4453125Z" }),
							/* @__PURE__ */ _jsx("path", { d: "M625.4987793,191.7473755c-1.6462402-1.2651367-4.0070801-.9560547-5.2722168.6901855-1.2648926,1.6462402-.9558105,4.0070801.6904297,5.2722168,1.6462402,1.2648926,4.0070801.9558105,5.2719727-.6904297,1.2651367-1.6462402.9560547-4.0070801-.6901855-5.2719727Z" })
						] })
					})]
				})
			]
		})
	]
});
export default SvgTasteWheelFull;
